/* ==========================================================================
   COOPS — storefront behaviour
   Progressive enhancement only: every control is a real <button>/<a>/<input>
   that works (or degrades to a link) without JS. The prototype's keyboard
   shim is deliberately NOT ported — semantic elements make it unnecessary.
   ========================================================================== */
(function () {
  'use strict';

  /* A/B test "bundle-default" (owner, 2026-10-22). Version A = the page as it was; version B = the product page opens
     on "2 pairs" and shows the bundle prices beside the price. Each visitor gets one version for 60 days (cookie
     coops_ab_bundle); team browsers (snippets/coops-team) and bots are left out. The version is written on the bag as a
     hidden attribute (_ab_bundle), so every order says which version its buyer saw. Remove this block, the two uses
     of AB below and the cart stamp when the test ends. */
  var AB = (function () {
    try {
      if (window.COOPS_TEAM || /bot|crawl|spider|slurp|lighthouse|preview|facebookexternalhit/i.test(navigator.userAgent)) return '';
      var m = /(^|;\s*)coops_ab_bundle=([AB])/.exec(document.cookie);
      if (m) return m[2];
      var v = Math.random() < 0.5 ? 'A' : 'B';
      document.cookie = 'coops_ab_bundle=' + v + '; path=/; max-age=5184000; samesite=lax';
      return v;
    } catch (e) { return ''; }
  })();
  window.COOPS_AB = AB;
  if (AB) document.addEventListener('cart:refresh', function () {
    try {
      if (sessionStorage.getItem('coops_ab_stamped') === AB) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _ab_bundle: AB } }) })
        .then(function (r) { if (r.ok) sessionStorage.setItem('coops_ab_stamped', AB); }).catch(function () {});
    } catch (e) {}
  });

  /* Preorder state, rendered once per page by snippets/coops-preorder (part 'meta'). */
  var PO = window.COOPS_PREORDER || { on: false };
  /* After the transition a product whose stock is not yet marked received is not purchasable (normal unavailable behaviour). */
  var PO_OK = !(PO.purchasable === false);
  /* Wording in the visitor's language: window.COOPS_T from snippets/coops-i18n (locale keys "coops.js.*"),
     English as the fallback. {name} placeholders are filled from vars. Colours and the Women's / Men's
     chart keep their English names as values; CN() and GN() give the names shown. */
  var TT = window.COOPS_T || {};
  function T(key, en, vars) {
    var str = TT[key] || en;
    if (vars) for (var k in vars) str = str.split('{' + k + '}').join(String(vars[k]));
    return str;
  }
  /* The bundle's saving on the add button (owner, 2026-10-22): "Add 2 pairs · $120 · Save $10", read from the chosen
     tier's own (translated, currency-correct) saving line; nothing when the tier has no saving. */
  function tierSave(scope) {
    var b = scope && scope.querySelector('[data-coops-tier][aria-pressed="true"]');
    var el = b && b.querySelector('.coops-pdp__tier-save');
    var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return t && /\d/.test(t) ? ' · ' + t : '';
  }
  function CN(c) { return (TT.colors && TT.colors[c]) || c; }
  function GN(g) { return g === 'Men’s' ? T('mens', 'Men’s') : g === 'Women’s' ? T('womens', 'Women’s') : g; }
  /* The size chart (Matt's brief, 2026-10-16): every picker opens on Men's unless the shopper chose Women's, which is
     remembered for the current visit (since 2026-10-21; was every visit). Each bag line carries the chart as the hidden property
     _size_scale, so a fit question or exchange can see which US number the shopper read. */
  var SCALE_KEY = 'coops_size_scale';
  /* Owner (2026-10-21): every visit starts on Men’s; the choice is kept only for the current visit (sessionStorage),
     and the old device-wide memory is cleared. */
  try { window.localStorage.removeItem(SCALE_KEY); } catch (e) {}
  function savedScale() { try { var v = window.sessionStorage.getItem(SCALE_KEY); return v === 'womens' ? 'Women’s' : v === 'mens' ? 'Men’s' : ''; } catch (e) { return ''; } }
  function saveScale(g) { try { window.sessionStorage.setItem(SCALE_KEY, g === 'Women’s' ? 'womens' : 'mens'); } catch (e) {} }
  function scaleItems(items, g) {
    return items.map(function (it) {
      var p = it.properties || {};
      if (!p._size_scale) p._size_scale = g === 'Women’s' ? "Women's" : "Men's";
      it.properties = p; return it;
    });
  }
  function poWord(n) { return n > 1 ? (PO.on ? T('preorder_n', 'Preorder {n} pairs', { n: n }) : T('add_n', 'Add {n} pairs', { n: n })) : (PO.on ? T('preorder_now', 'Preorder now') : T('add_to_bag', 'Add to bag')); }
  /* Outside USD a bare "$92" is ambiguous: every button that quotes a price names the currency (owner, 2026-09-15). */
  function moneyLabel(str) { var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active; var cc = window.Shopify && window.Shopify.country; return (str && cur && (cur !== 'USD' || (cc && cc !== 'US')) && !/\b[A-Z]{3}\b/.test(str)) ? str + ' ' + cur : str; }
  /* Size preorders (snippets/coops-backorder): sold-out sizes open for preorder from the next shipment, extra 10% off. */
  var BO = window.COOPS_BACKORDER || { ids: [] };
  function isBO(id) { return BO.ids.indexOf(Number(id)) !== -1; }
  /* Marks a size button and returns whether it is a preorder size. */
  function paintBO(btn, v) {
    var po = !!(v && v.available && isBO(v.id));
    if (po) btn.setAttribute('data-coops-po', BO.badge || 'Preorder'); else btn.removeAttribute('data-coops-po');
    return po;
  }
  /* One note under the add button while a preorder size is chosen. */
  function boNote(anchor, show) {
    if (!anchor || !anchor.parentNode) return;
    var n = anchor.parentNode.querySelector('[data-coops-bo-note]');
    if (!n && show) { n = document.createElement('p'); n.className = 'coops-bo-note'; n.setAttribute('data-coops-bo-note', ''); n.textContent = BO.note; anchor.parentNode.insertBefore(n, anchor.nextSibling); }
    if (n) n.hidden = !show;
  }
  function poItems(items) {
    items = items.map(function (it) {
      if (isBO(it.id)) { var p = it.properties || {}; p['Ships'] = BO.label; it.properties = p; }
      return it;
    });
    if (!PO.on) return items;
    return items.map(function (it) {
      var props = it.properties || {};
      props['Preorder'] = PO.label; props['_preorder_batch'] = PO.batch; props['_preorder_ship_date'] = PO.ship_date;
      it.properties = props; if (PO.plan) it.selling_plan = PO.plan; return it;
    });
  }

  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- Header */
  function initHeader(root) {
    var menu = $('[data-coops-menu]', root);
    if (!menu) return;
    var openers = $$('[data-coops-menu-open]', root);
    var closers = $$('[data-coops-menu-close]', menu);
    var lastFocus = null;

    function setOpen(open) {
      menu.setAttribute('open-state', open ? 'true' : 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocus = document.activeElement;
        var first = $('a, button', menu);
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    openers.forEach(function (b) { on(b, 'click', function () { setOpen(true); }); });
    closers.forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('open-state') === 'true') setOpen(false);
    });
  }

  /* ------------------------------------------------------------------ Hero */
  function initHero(root) {
    var hero = $('[data-coops-hero]', root);
    if (!hero) return;
    /* A slide whose phone picture differs from the desktop one (2026-10-13: slide 1 shows the shoes only on phones)
       carries its own alt text; the one <img> takes the alt of the picture actually on screen. */
    var altMq = window.matchMedia('(max-width: 749px)');
    var altImgs = $$('img[data-alt-mobile]', hero);
    function syncAlt() {
      altImgs.forEach(function (img) {
        if (!img.hasAttribute('data-alt-desktop')) img.setAttribute('data-alt-desktop', img.alt);
        img.alt = altMq.matches ? img.getAttribute('data-alt-mobile') : img.getAttribute('data-alt-desktop');
      });
    }
    if (altImgs.length) { syncAlt(); if (altMq.addEventListener) altMq.addEventListener('change', syncAlt); }
    var slides = $$('[data-coops-slide]', hero);
    var dots = $$('[data-coops-dot]', hero);
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(hero.getAttribute('data-autoplay-ms') || '6000', 10);
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Slides 2+ are lazy so they do not compete with the LCP image. Only the
       next slide is fetched once the page has loaded (well before the first
       rotation); each later slide is fetched when the one before it shows, so
       a first visit downloads one extra photograph, not four (performance,
       2026-09-16: the four warmed slides were ~420 KB in the first seconds). */
    function warmSlide(i) {
      var s = slides[(i + slides.length) % slides.length];
      if (!s) return;
      $$('img[data-coops-warm]', s).forEach(function (img) { img.loading = 'eager'; img.removeAttribute('data-coops-warm'); });
    }
    function warm() { warmSlide(index + 1); }
    if (document.readyState === 'complete') window.setTimeout(warm, 800);
    else on(window, 'load', function () { window.setTimeout(warm, 800); });

    function show(n) {
      index = (n + slides.length) % slides.length;
      warmSlide(index); warmSlide(index + 1);
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      /* Each slide carries its own dot group, so a dot's number is its
         position inside its group, not its position among every dot. */
      dots.forEach(function (d) {
        var group = d.parentNode ? Array.prototype.slice.call(d.parentNode.querySelectorAll('[data-coops-dot]')) : [d];
        var n = group.indexOf(d);
        var dot = $('.coops-hero__dot', d) || d;
        dot.setAttribute('aria-current', n === index ? 'true' : 'false');
        d.setAttribute('aria-label', T('slide_n', 'Show slide {n} of {total}', { n: n + 1, total: slides.length }));
        d.setAttribute('aria-pressed', n === index ? 'true' : 'false');
      });
    }

    function start() {
      if (!autoplay || reduced) return;
      stop();
      timer = window.setInterval(function () { show(index + 1); }, delay);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      on(d, 'click', function () {
        var group = d.parentNode ? Array.prototype.slice.call(d.parentNode.querySelectorAll('[data-coops-dot]')) : [d];
        show(group.indexOf(d)); stop(); start();
      });
    });

    on(hero, 'mouseenter', stop);
    on(hero, 'mouseleave', start);
    on(hero, 'focusin', stop);
    /* Swipe between slides on touch screens (owner, live 2026-09-15): a mostly horizontal move of 40px or more; vertical scrolling is untouched. */
    var tx = null, ty = null;
    on(hero, 'touchstart', function (e) { var t = e.touches && e.touches[0]; if (!t) return; tx = t.clientX; ty = t.clientY; }, { passive: true });
    on(hero, 'touchend', function (e) {
      if (tx === null) return;
      var t = e.changedTouches && e.changedTouches[0]; if (!t) { tx = ty = null; return; }
      var dx = t.clientX - tx, dy = t.clientY - ty; tx = ty = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      show(index + (dx < 0 ? 1 : -1)); stop(); start();
    }, { passive: true });
    on(document, 'visibilitychange', function () { document.hidden ? stop() : start(); });

    show(0);
    start();
  }

  /* -------------------------------------------------------- Pick your pair */
  function initPicker(root) {
    var picker = $('[data-coops-picker]', root);
    if (!picker) return;

    /* Mobile style switch: shows one card at a time under 750px */
    var switches = $$('[data-coops-style]', picker);
    var cards = $$('[data-coops-card]', picker);
    var mq = window.matchMedia('(min-width: 750px)');
    /* The activity-page layout shows one card at every width. */
    var single = picker.hasAttribute('data-coops-single');

    function applyStyle(styleKey) {
      switches.forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-coops-style') === styleKey ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var mine = c.getAttribute('data-coops-card') === styleKey;
        if (mq.matches && !single) c.removeAttribute('hidden');
        else if (mine) c.removeAttribute('hidden');
        else c.setAttribute('hidden', '');
      });
    }

    switches.forEach(function (b) {
      on(b, 'click', function () { applyStyle(b.getAttribute('data-coops-style')); });
    });
    on(mq, 'change', function () {
      var current = (switches.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0]);
      applyStyle(current ? current.getAttribute('data-coops-style') : (switches[0] && switches[0].getAttribute('data-coops-style')));
    });
    if (switches.length) {
      var initial = switches.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || switches[0];
      applyStyle(initial.getAttribute('data-coops-style'));
    }

    cards.forEach(initCard);
  }

  /* Pair boxes (owner, 2026-10-22): the saving in the corner reads on two lines, "Save" above the amount. The space
     stays in the text, so the add button still reads "Save $10". */
  function splitSaves(scope) {
    $$('.coops-pdp__tier-save', scope).forEach(function (el) {
      if (el.hasAttribute('data-coops-split')) return;
      el.setAttribute('data-coops-split', '');
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      var m = /\s(?=\S*\d)/.exec(t);
      if (!m) return;
      el.textContent = '';
      el.appendChild(document.createTextNode(t.slice(0, m.index) + ' '));
      el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(t.slice(m.index + 1)));
    });
  }
  function initCard(card) {
    splitSaves(card);
    var dataEl = $('[data-coops-variants]', card);
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    /* Select mode (activity pages): sizes select, one button adds. Quick
       mode (home): tapping a size adds it. */
    var selectMode = card.hasAttribute('data-coops-select');
    var tierBtns = $$('[data-coops-tier]', card);
    var qtyInput = $('[data-coops-qty]', card);
    var idInput = $('[data-coops-id]', card);
    var cta = $('[data-coops-card-cta]', card);

    var state = {
      color: card.getAttribute('data-initial-color') || '',
      gender: savedScale() || card.getAttribute('data-initial-gender') || 'Men’s',
      /* Quick add asks for the colour (Matt's brief, 2026-10-16: the Travel page added the first colour unasked):
         nothing is added until the shopper has tapped a colour, unless there is only one. */
      colorPicked: false,
      size: '',
      qty: tierBtns.length ? Number(tierBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0]
        ? tierBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0].getAttribute('data-coops-tier') : 1) || 1 : 1
    };

    var img = $('[data-coops-card-image]', card);
    var quickLabel = $('[data-coops-quickadd-label]', card);
    var form = $('[data-coops-add-form]', card);
    var live = $('[data-coops-live]', card);

    var colorBtns = $$('[data-coops-color]', card);
    var genderBtns = $$('button[data-coops-gender]:not([data-pair-gender])', card);
    var sizeBtns = $$('button[data-coops-size]:not([data-pair-size])', card);
    var singleOnly = $$('[data-coops-single-only]', card);
    var cardImgSrc = img ? img.getAttribute('src') : '';

    function moneyTimes(str, n) {
      var m = /^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/.exec(str || '');
      if (!m) return '';
      var v = Math.round(parseFloat(m[2].replace(/,/g, '')) * n * 100) / 100;
      return m[1] + String(v) + m[3];
    }
    function selected() {
      if (!state.size) return null;
      var v = variantFor(state.color, state.size);
      return v && v.available ? v : null;
    }

    /* Pair builder for the single-card layout: the other style's data lives on its (hidden) card. */
    var myStyle = card.getAttribute('data-coops-card');
    var picker = card.closest('[data-coops-picker]');
    function cardFor(key) { return picker ? $('[data-coops-card="' + key + '"]', picker) : null; }
    function variantsOfCard(c) { var el = c && $('[data-coops-variants]', c); try { return el ? JSON.parse(el.textContent) || [] : []; } catch (e) { return []; } }
    var builderEl = selectMode ? $('[data-coops-builder]', card) : null;
    var builder = null;
    if (builderEl) {
      var styleList = ['high', 'low'].map(function (k) { var c = cardFor(k); return c ? { key: k, label: c.getAttribute('data-style-label') || k, price: c.getAttribute('data-style-price') || '' } : null; }).filter(Boolean);
      builder = createBuilder({
        root: builderEl,
        styles: styleList,
        colors: colorsFrom(card),
        tables: sizeTablesFrom($('.coops-sizes__grid', card) || card),
        variantsFor: function (k) { return k === myStyle ? variants : variantsOfCard(cardFor(k)); },
        imageFor: function (k, color) { var c = cardFor(k) || card; return c.getAttribute('data-image-' + slug(color)) || ''; },
        getMain: function () { return { style: myStyle, color: state.color, size: state.size, gender: state.gender }; },
        qty: function () { return state.qty; },
        /* While a pair is being edited, the picture and the views under it show that pair's colour and style (owner, live 2026-09-15). */
        onPreview: function (src, color, styleKey) { cardPreview = src || ''; previewColor = src ? (color || '') : ''; previewStyle = src ? (styleKey || '') : ''; applyCardImage(); },
        onChange: function () { render(); }
      });
    }
    var cardPreview = '';
    var previewColor = '';
    var previewStyle = '';
    /* Views under the picture (activity pages): the product page's six (side, rear,
       back, front, outsole, on foot) for the chosen colour (or the pair being edited, whose style may be the other
       card's); the pressed one fills the main frame. A colour or style change
       goes back to the side view, as on the product page. */
    var views = $$('[data-coops-view]', card);
    var viewKey = 'side';
    var viewSig = '';
    function viewCard() { return (previewStyle && cardFor(previewStyle)) || card; }
    function viewColorNow() { return previewColor || state.color; }
    function viewSrc(v, color, c) { c = c || viewCard(); return v === 'side' ? c.getAttribute('data-image-' + slug(color)) : c.getAttribute('data-image-' + v + '-' + slug(color)); }
    function applyViews() {
      if (!views.length) return;
      var c = viewCard(), color = viewColorNow(), sig = (previewStyle || myStyle) + '|' + color;
      if (viewSig !== sig) { viewSig = sig; viewKey = 'side'; }
      views.forEach(function (b) {
        var v = b.getAttribute('data-coops-view');
        var src = viewSrc(v, color, c);
        var im = $('img', b);
        /* The strip shows small files; only the main frame takes the 1000px one. */
        var small = src ? src.replace(/([?&]width=)[0-9]+/, '$1320') : '';
        if (im && small && im.getAttribute('src') !== small) { im.setAttribute('src', small); im.removeAttribute('srcset'); }
        b.hidden = !src;
        b.setAttribute('aria-pressed', v === viewKey ? 'true' : 'false');
      });
    }
    views.forEach(function (b) {
      on(b, 'click', function () { viewKey = b.getAttribute('data-coops-view'); applyViews(); applyCardImage(); });
    });
    function applyCardImage() {
      if (!img) return;
      applyViews();
      var c = viewCard(), color = viewColorNow();
      var src = (viewKey !== 'side' && viewSrc(viewKey, color, c)) || cardPreview || c.getAttribute('data-image-' + slug(color));
      var alt = cardPreview ? '' : card.getAttribute('data-alt-' + slug(state.color));
      if (src && img.getAttribute('src') !== src) { img.setAttribute('src', src); img.removeAttribute('srcset'); if (alt) img.setAttribute('alt', alt); }
    }
    var cardFrame = img ? img.closest('[data-coops-card-frame]') : null;
    function fitCardFrame() { if (cardFrame && img && img.naturalWidth && img.naturalHeight) cardFrame.style.setProperty('--coops-r', (img.naturalWidth / img.naturalHeight).toFixed(3)); }
    if (img) { on(img, 'load', fitCardFrame); if (img.complete) fitCardFrame(); }

    function variantFor(color, size) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].color === color && variants[i].size === size) return variants[i];
      }
      return null;
    }

    function availableSizesFor(color) {
      var out = {};
      variants.forEach(function (v) { if (v.color === color && v.available) out[v.size] = true; });
      return out;
    }

    function render() {
      colorBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-coops-color') === state.color && (state.colorPicked || colorBtns.length < 2) ? 'true' : 'false');
      });
      genderBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-coops-gender') === state.gender ? 'true' : 'false');
      });

      /* Swap the colourway shot (or keep the pair being edited in view) */
      if (typeof applyCardImage === 'function') applyCardImage();

      if (quickLabel) quickLabel.textContent = T('quick_add', 'Quick add • {color}', { color: CN(state.color) });

      var tierPrice = '';
      tierBtns.forEach(function (b) {
        var on = Number(b.getAttribute('data-coops-tier')) === state.qty;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) tierPrice = b.getAttribute('data-coops-tier-price') || '';
      });
      if (qtyInput) qtyInput.value = String(state.qty);
      paintTierHint(card, state.qty, tierBtns);

      /* Show only the rows for the selected size chart, point each button at
         the variant for the chosen colourway, and disable anything the
         catalogue does not stock. */
      var anyVariants = variants.length > 0;
      sizeBtns.forEach(function (btn) {
        btn.hidden = btn.getAttribute('data-coops-gender') !== state.gender;
        var size = btn.getAttribute('data-coops-size');
        var v = variantFor(state.color, size);
        btn.value = v ? String(v.id) : '';
        btn.disabled = !v || !v.available || !PO_OK;
        var bo = paintBO(btn, v);
        var a11y = $('[data-coops-size-a11y]', btn);
        if (a11y) {
          a11y.textContent = (btn.disabled
            ? T('size_unavailable', 'Size {size} in {color} is unavailable', { size: size, color: CN(state.color) })
            : (selectMode ? T('select_size_n', 'Select size {size}', { size: size }) : T('add_size', 'Add {color}, size {size}, to your bag', { color: CN(state.color), size: size }))) + (bo && !btn.disabled ? ', ' + BO.a11y : '');
        }
        if (!anyVariants) {
          /* No product connected (or it is still Draft): keep the design
             visible but make it plain nothing can be added. */
          btn.disabled = true;
        }
        if (selectMode && btn.type !== 'submit') btn.setAttribute('aria-pressed', !btn.disabled && size === state.size ? 'true' : 'false');
        else btn.removeAttribute('aria-pressed');
      });

      if (selectMode) {
        var chosen = selected();
        if (idInput) idInput.value = chosen ? String(chosen.id) : '';
        var multi = state.qty > 1 && builder && builder.isMixed();
        boNote(cta, !!(chosen && isBO(chosen.id) && !multi));
        singleOnly.forEach(function (el) { el.hidden = !!multi; });
        if (builder && (state.qty > 1 || !builderEl.hidden)) builder.render();
        if (cta) {
          var need = multi ? builder.needsSize() : !chosen;
          if (need) {
            cta.textContent = multi ? T('select_each', 'Select each pair’s size') : T('select_size', 'Select your size');
            cta.setAttribute('data-needs-size', 'true');
          } else if (state.qty > 1) {
            var total = tierPrice ? moneyTimes(tierPrice, state.qty) : '';
            cta.textContent = poWord(state.qty) + (total ? ' · ' + moneyLabel(total) : '') + tierSave(card);
            cta.setAttribute('data-needs-size', 'false');
          } else {
            cta.textContent = poWord(1) + ' · ' + moneyLabel(chosen.price || cta.getAttribute('data-price') || '');
            cta.setAttribute('data-needs-size', 'false');
          }
        }
      }
    }

    colorBtns.forEach(function (b) {
      on(b, 'click', function () { state.color = b.getAttribute('data-coops-color'); state.colorPicked = true; var row = $('.coops-swatches', card); if (row) row.classList.remove('is-asking'); render(); });
    });
    genderBtns.forEach(function (b) {
      on(b, 'click', function () {
        state.gender = b.getAttribute('data-coops-gender');
        saveScale(state.gender);
        /* A size the new chart does not list (women's 5XS; men's XL and up) would otherwise stay chosen with no pressed button to show it, and the add button would still add it (B274). */
        if (state.size && !sizeBtns.some(function (s) { return s.getAttribute('data-coops-gender') === state.gender && s.getAttribute('data-coops-size') === state.size; })) state.size = '';
        render();
      });
    });
    tierBtns.forEach(function (b) {
      on(b, 'click', function () {
        state.qty = Number(b.getAttribute('data-coops-tier')) || 1;
        render();
        if (builder && state.qty > 1) { builder.render(); render(); }
      });
    });
    if (selectMode) {
      sizeBtns.forEach(function (b) {
        on(b, 'click', function () { if (!b.disabled) { state.size = b.getAttribute('data-coops-size'); render(); } });
      });
    }

    function nudgeToSizes() {
      var grid = $('.coops-sizes', card) || card;
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = $('button[data-coops-size]:not([disabled]):not([hidden])', card);
      if (live) live.textContent = T('choose_size_first', 'Choose a size first.');
      window.setTimeout(function () { if (first) first.focus(); }, 450);
    }
    function needsColour() { return colorBtns.length > 1 && !state.colorPicked; }
    function askColour() {
      var row = $('.coops-swatches', card);
      var msg = T('choose_colour_first', 'Choose a colour first.');
      if (live) live.textContent = msg;
      if (quickLabel) quickLabel.textContent = msg;
      if (row) { row.classList.remove('is-asking'); void row.offsetWidth; row.classList.add('is-asking'); row.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      window.setTimeout(function () { if (colorBtns[0]) colorBtns[0].focus({ preventScroll: true }); }, 450);
    }

    /* Select mode: the one add button submits the chosen variant × tier. */
    if (form && selectMode) {
      on(form, 'submit', function (e) {
        var multi = state.qty > 1 && builder && builder.isMixed();
        var chosen = selected();
        var items;
        if (needsColour()) { e.preventDefault(); askColour(); return; }
        if (multi) {
          if (builder.needsSize()) { e.preventDefault(); if (live) live.textContent = T('choose_each', 'Choose a size for each pair.'); builderEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          items = builder.items();
        } else {
          if (!chosen) { e.preventDefault(); nudgeToSizes(); return; }
          items = [{ id: Number(chosen.id), quantity: state.qty }];
        }
        if (!window.fetch) return; /* id + quantity are set: let the form post */
        e.preventDefault();
        var was = cta ? cta.textContent : '';
        if (cta) { cta.disabled = true; cta.textContent = T('adding', 'Adding…'); }
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: poItems(scaleItems(items, state.gender)) })
        })
          .then(function (r) { return r.json().then(function (jj) { return { ok: r.ok, body: jj }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || T('add_error', 'Could not add to bag.'));
            if (live) live.textContent = multi ? T('added_n', '{n} pairs added to your bag.', { n: state.qty }) : T('added_one', '{item} added to your bag.', { item: '1 × ' + CN(state.color) + ' ' + state.size });
            if (cta) cta.textContent = T('added', 'Added');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            refreshBagCount();
            window.setTimeout(function () { if (cta) cta.disabled = false; render(); }, 1400);
          })
          .catch(function (err) {
            if (live) live.textContent = String(err.message || err);
            if (cta) { cta.disabled = false; cta.textContent = was; }
            render();
          });
      });
    }

    /* Quick mode: tapping a size adds it. With no JS the same button posts
       the form to /cart/add and Shopify handles it server-side, so this is
       enhancement only — never the thing that makes the control work. */
    if (form && !selectMode) {
      /* Which size was tapped. Safari — every browser on an iPhone, and Safari
         and Firefox on a Mac — does not focus a button on tap, so
         document.activeElement is <body> there. The old fallback then took the
         first enabled size in the form, 5XS, whatever the customer tapped
         (B274, customer on a phone, 2026-09-26: tapped 4XS, bag held 5XS).
         Now: the submit event's own submitter, else the size button last
         clicked (the click always precedes the submit), else the focused one.
         With none of those, the form posts natively and the browser sends the
         tapped button's own id. Never a guess. */
      var tapped = null;
      on(form, 'click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('button[data-coops-size]') : null;
        tapped = b && form.contains(b) ? b : null;
      });
      on(form, 'submit', function (e) {
        var btn = e.submitter || tapped || document.activeElement;
        tapped = null;
        if (!btn || !btn.matches || !btn.matches('button[data-coops-size]') || !form.contains(btn)) return; /* let the form post */
        if (needsColour()) { e.preventDefault(); askColour(); return; }
        if (!window.fetch || btn.disabled || !btn.value) return; /* let the form post */

        e.preventDefault();
        var size = btn.getAttribute('data-coops-size');
        sizeBtns.forEach(function (b) { b.disabled = true; });

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: poItems(scaleItems([{ id: Number(btn.value), quantity: state.qty }], state.gender)) })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || T('add_error', 'Could not add to bag.'));
            btn.setAttribute('data-added', 'true');
            if (live) live.textContent = T('added_one', '{item} added to your bag.', { item: CN(state.color) + ' ' + size });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            refreshBagCount();
            window.setTimeout(function () { btn.removeAttribute('data-added'); render(); }, 1400);
          })
          .catch(function (err) {
            if (live) live.textContent = String(err.message || err);
            render();
          });
      });
    }

    render();
  }

  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }


  /* ---------------------------------------------------------- Pair builder */
  /* "Your N pairs · Mix freely": one row per pair; pair 1 is the main pick
     and the others follow it until edited. Pure DOM, re-rendered on change;
     the host supplies styles, variants, images and the current main pick. */
  function createBuilder(cfg) {
    var root = cfg.root;
    var listEl = $('[data-coops-builder-list]', root);
    var titleEl = $('[data-coops-builder-title]', root);
    var edits = {};
    var editing = null;
    /* Owner (2026-10-22): bundles start as "same for all": the page's own colour and size pickers set every pair and the
       builder shows one summary line; "Make them different" opens one row per pair (inline colour swatches, size &
       style editor); "Make them all the same" goes back. */
    var mixed = false;

    function main() { return cfg.getMain(); }
    function configs() {
      var q = cfg.qty();
      var m = main();
      var lead = edits[0] ? assign({}, m, edits[0]) : m;
      var out = [];
      for (var i = 0; i < q; i++) out.push(i === 0 ? assign({}, lead) : assign({}, edits[i] || lead));
      return out;
    }
    function assign(t) { for (var i = 1; i < arguments.length; i++) { var o = arguments[i]; if (o) for (var k in o) t[k] = o[k]; } return t; }
    function variantFor(c) {
      var list = cfg.variantsFor(c.style) || [];
      for (var i = 0; i < list.length; i++) if (list[i].color === c.color && list[i].size === c.size) return list[i];
      return null;
    }
    function availableSizes(c) {
      var out = {};
      (cfg.variantsFor(c.style) || []).forEach(function (v) { if (v.color === c.color && v.available) out[v.size] = true; });
      return out;
    }
    function needsSize() {
      return configs().some(function (c) { var v = variantFor(c); return !v || !v.available; });
    }
    function items() {
      var by = {};
      configs().forEach(function (c) {
        var v = variantFor(c); if (!v) return;
        var k = v.id + '|' + c.gender;
        if (!by[k]) by[k] = { id: Number(v.id), quantity: 0, properties: { _size_scale: c.gender === 'Women’s' ? "Women's" : "Men's" } };
        by[k].quantity++;
      });
      return Object.keys(by).map(function (k) { return by[k]; });
    }
    function styleLabel(key) { var st = cfg.styles.filter(function (s) { return s.key === key; })[0]; return st ? st.label : key; }
    function esc(str) { return String(str).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

    function render() {
      var q = cfg.qty();
      if (q < 2) { root.hidden = true; editing = null; cfg.onPreview(null); return; }
      root.hidden = false;
      root.classList.toggle('is-mixed', mixed);
      if (titleEl) titleEl.textContent = mixed ? T('your_n_pairs', 'Your {n} pairs', { n: q }) : T('all_n_pairs', 'All {n} pairs', { n: q });
      var cs = configs();
      var html = '';
      if (!mixed) {
        var c0 = cs[0], v0 = variantFor(c0), s0 = !!(v0 && v0.available), img0 = cfg.imageFor(c0.style, c0.color) || '';
        var meta0 = styleLabel(c0.style) + ' • ' + CN(c0.color) + ' • ' + GN(c0.gender) + ' • ' + (s0 ? c0.size : T('pick_size', 'pick a size'));
        html += '<li class="coops-builder__pair coops-builder__pair--all"' + (s0 ? '' : ' data-pair-pending') + '><div class="coops-builder__summary coops-builder__summary--static">';
        html += '<span class="coops-builder__thumb">' + (img0 ? '<img src="' + esc(img0) + '" alt="" loading="lazy" decoding="async">' : '') + '<b class="coops-builder__count">×' + q + '</b></span>';
        html += '<span class="coops-builder__text"><span class="coops-builder__label">' + esc(T('all_n_pairs', 'All {n} pairs', { n: q })) + '</span><span class="coops-builder__meta">' + esc(meta0) + '</span></span></div></li>';
        html += '<li class="coops-builder__mixrow"><button type="button" class="coops-builder__mix" data-pair-mix>' + esc(T('make_different', 'Make them different')) + '</button></li>';
        listEl.innerHTML = html;
        cfg.onPreview(null);
        return;
      }
      cs.forEach(function (c, i) {
        var v = variantFor(c);
        var sized = !!(v && v.available);
        var label = i === 0 ? T('pair_main', 'Pair 1, your main pick') : T('pair_n', 'Pair {n}', { n: i + 1 }) + (edits[i] ? ', ' + T('customised', 'customised') : '');
        var meta = styleLabel(c.style) + ' • ' + CN(c.color) + ' • ' + GN(c.gender) + ' • ' + (sized ? c.size : T('pick_size', 'pick a size')) + (sized && isBO(v.id) ? ' • ' + (BO.badge || 'Preorder') : '');
        var img = cfg.imageFor(c.style, c.color) || '';
        var open = editing === i;
        html += '<li class="coops-builder__pair' + (open ? ' is-open' : '') + '" data-pair="' + i + '"' + (sized ? '' : ' data-pair-pending') + '>';
        html += '<button type="button" class="coops-builder__summary" data-pair-toggle="' + i + '" aria-expanded="' + (open ? 'true' : 'false') + '">';
        html += '<span class="coops-builder__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>';
        html += '<span class="coops-builder__text"><span class="coops-builder__label">' + esc(label) + '</span><span class="coops-builder__meta">' + esc(meta) + '</span></span>';
        html += '<span class="coops-builder__edit">' + (open ? T('close', 'Close') : T('size_style', 'Size & style')) + '</span></button>';
        if (!open) {
          /* One-tap colour for each pair, right in its row. */
          html += '<div class="coops-builder__quick" role="group" aria-label="' + esc(T('colour', 'Colour')) + '">';
          cfg.colors.forEach(function (col) {
            html += '<button type="button" class="coops-swatch coops-swatch--sm" data-pair-color="' + esc(col.name) + '" aria-pressed="' + (col.name === c.color ? 'true' : 'false') + '" aria-label="' + esc(CN(col.name)) + '"><span class="coops-swatch__chip" style="background:linear-gradient(180deg,' + esc(col.upper) + ' 0 50%,' + esc((c.style === 'low' ? col.soleLow : col.soleHigh) || col.sole) + ' 50% 100%)"></span></button>';
          });
          html += '</div>';
        }
        if (open) {
          html += '<div class="coops-builder__editor">';
          html += '<div class="coops-builder__styles" role="group" aria-label="' + esc(T('style', 'Style')) + '">';
          cfg.styles.forEach(function (st) {
            html += '<button type="button" class="coops-builder__style" data-pair-style="' + esc(st.key) + '" aria-pressed="' + (st.key === c.style ? 'true' : 'false') + '">' + esc(st.label) + '</button>'; // owner (2026-09-13): no prices on the style buttons
          });
          html += '</div>';
          html += '<div class="coops-builder__colors" role="group" aria-label="' + esc(T('colour', 'Colour')) + '">';
          cfg.colors.forEach(function (col) {
            html += '<button type="button" class="coops-swatch coops-swatch--sm" data-pair-color="' + esc(col.name) + '" aria-pressed="' + (col.name === c.color ? 'true' : 'false') + '" aria-label="' + esc(CN(col.name)) + '"><span class="coops-swatch__chip" style="background:linear-gradient(180deg,' + esc(col.upper) + ' 0 50%,' + esc((c.style === 'low' ? col.soleLow : col.soleHigh) || col.sole) + ' 50% 100%)"></span></button>';
          });
          html += '<span class="coops-builder__colorname">' + esc(CN(c.color)) + '</span></div>';
          html += '<div class="coops-builder__sizehead"><span class="coops-builder__sizelabel">' + esc(T('size_us', 'Size · US {gender}', { gender: GN(c.gender) })) + '</span>';
          html += '<div class="coops-gender" role="group" aria-label="' + esc(T('size_chart', 'Size chart')) + '">';
          ['Women’s', 'Men’s'].forEach(function (g) { html += '<button type="button" class="coops-gender__btn" data-pair-gender="' + g + '" aria-pressed="' + (g === c.gender ? 'true' : 'false') + '">' + esc(GN(g)) + '</button>'; });
          html += '</div></div>';
          var table = c.gender === 'Men’s' ? cfg.tables.mens : cfg.tables.womens;
          var avail = availableSizes(c);
          html += '<div class="coops-sizes__grid coops-sizes__grid--builder" role="group" aria-label="' + esc(T('size', 'Size')) + '">';
          table.forEach(function (row) {
            var on = row[0] === c.size && avail[row[0]];
            var rv = variantFor({ style: c.style, color: c.color, size: row[0] });
            var rbo = !!(rv && rv.available && isBO(rv.id));
            html += '<button type="button" class="coops-size" data-pair-size="' + esc(row[0]) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (rbo ? ' data-coops-po="' + esc(BO.badge || 'Preorder') + '"' : '') + (avail[row[0]] ? '' : ' disabled') + '><span class="coops-size__face"><span class="coops-size__label">' + esc(row[0]) + '</span><span class="coops-size__value">' + esc(row[1]) + '</span>' + (row[2] ? '<span class="coops-size__alt">' + esc(row[2]) + '</span>' : '') + '</span></button>';
          });
          html += '</div>';
          html += '<button type="button" class="coops-btn coops-btn--primary coops-btn--block coops-builder__done" data-pair-done>' + esc(T('done', 'Done')) + ' · ' + esc(CN(c.color)) + ' · ' + (sized ? esc(c.size) : esc(T('pick_size', 'pick a size'))) + '</button>';
          html += '</div>';
        }
        html += '</li>';
      });
      html += '<li class="coops-builder__mixrow"><button type="button" class="coops-builder__mix coops-builder__mix--same" data-pair-same>' + esc(T('make_same', 'Make them all the same')) + '</button></li>';
      listEl.innerHTML = html;
      cfg.onPreview(editing === null ? null : cfg.imageFor(cs[editing].style, cs[editing].color), editing === null ? '' : cs[editing].color, editing === null ? '' : cs[editing].style);
    }

    function setPair(i, patch) {
      var current = configs()[i];
      edits[i] = assign({}, current, patch);
      // A colour or style change can invalidate the size; keep it only if it exists.
      var v = variantFor(edits[i]);
      if (!v) { var alt = availableSizes(edits[i]); if (!alt[edits[i].size]) edits[i].size = edits[i].size; }
      render();
      cfg.onChange();
    }

    on(root, 'click', function (e) {
      var t = e.target.closest('[data-pair-toggle], [data-pair-style], [data-pair-color], [data-pair-gender], [data-pair-size], [data-pair-done], [data-pair-mix], [data-pair-same]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-pair-mix')) { mixed = true; edits = {}; editing = null; render(); cfg.onChange(); return; }
      if (t.hasAttribute('data-pair-same')) { mixed = false; edits = {}; editing = null; render(); cfg.onChange(); return; }
      var pairEl = t.closest('[data-pair]');
      var i = pairEl ? Number(pairEl.getAttribute('data-pair')) : 0;
      if (t.hasAttribute('data-pair-toggle')) { editing = editing === i ? null : i; render(); return; }
      if (t.hasAttribute('data-pair-done')) { editing = null; render(); cfg.onChange(); return; }
      if (t.hasAttribute('data-pair-style')) { setPair(i, { style: t.getAttribute('data-pair-style') }); return; }
      if (t.hasAttribute('data-pair-color')) { setPair(i, { color: t.getAttribute('data-pair-color') }); return; }
      if (t.hasAttribute('data-pair-gender')) { setPair(i, { gender: t.getAttribute('data-pair-gender') }); return; }
      if (t.hasAttribute('data-pair-size')) { if (!t.disabled) setPair(i, { size: t.getAttribute('data-pair-size') }); return; }
    });

    return {
      render: render, configs: configs, needsSize: needsSize, items: items,
      isActive: function () { return cfg.qty() >= 2; },
      isMixed: function () { return mixed; },
      reset: function () { edits = {}; editing = null; mixed = false; },
      summary: function () { var cs = configs(); return cs.map(function (c) { return c.size || '?'; }).join(' · '); }
    };
  }


  /* Saving hint beside "How many pairs" (mobile design): from the tier cards' own saving lines. */
  function paintTierHint(scope, qty, tierBtns) {
    var el = $('[data-coops-tier-hint]', scope);
    if (!el) return;
    // Owner (2026-09-13): no "Save up to" / "You save" hint at any width.
    el.textContent = '';
    return;
    var savings = tierBtns.map(function (b) { var s = $('.coops-pdp__tier-save', b); var m = s && /\$([0-9]+)/.exec(s.textContent); return m ? Number(m[1]) : 0; });
    var max = Math.max.apply(null, savings.concat([0]));
    var current = tierBtns.filter(function (b) { return Number(b.getAttribute('data-coops-tier')) === qty; })[0];
    var cur = current ? (/\$([0-9]+)/.exec(($('.coops-pdp__tier-save', current) || {}).textContent || '') || [])[1] : null;
    if (!max) { el.textContent = ''; return; }
    el.textContent = qty > 1 && cur ? 'You save $' + cur : 'Save up to $' + max;
  }

  /* Size tables from the rendered size buttons: [[letter, US range], …] per chart. */
  function sizeTablesFrom(scope) {
    var t = { womens: [], mens: [] };
    $$('button[data-coops-size]', scope).forEach(function (b) {
      var row = [b.getAttribute('data-coops-size'), (($('.coops-size__value', b) || {}).textContent || '').trim(), (($('.coops-size__alt', b) || {}).textContent || '').trim()];
      (b.getAttribute('data-coops-gender') === 'Men’s' ? t.mens : t.womens).push(row);
    });
    return t;
  }
  function colorsFrom(scope) {
    /* Read the raw style attribute: the browser rewrites hex colours as
       rgb(...) with spaces in the live style, which a naive split misses. */
    return $$('[data-coops-color]', scope).map(function (b) {
      var chip = $('.coops-swatch__chip', b);
      var raw = chip ? (chip.getAttribute('style') || '') : '';
      var m = /linear-gradient\(\s*180deg\s*,\s*(#[0-9a-fA-F]{3,8}|rgba?\([^)]*\))\s*0%?\s+50%\s*,\s*(#[0-9a-fA-F]{3,8}|rgba?\([^)]*\))/.exec(raw);
      var upper = m ? m[1] : '', sole = m ? m[2] : '';
      if (!upper && chip) {
        var cs = getComputedStyle(chip).backgroundImage || '';
        var m2 = /linear-gradient\([^,]*,\s*(rgba?\([^)]*\))[^,]*,\s*(rgba?\([^)]*\))/.exec(cs);
        if (m2) { upper = m2[1]; sole = m2[2]; }
      }
      /* Product page swatches carry both soles (dark on the High Top, cream on the Low Top) so each pair row shows its own. */
      var sHigh = b.getAttribute('data-sole-high'), sLow = b.getAttribute('data-sole-low');
      return { name: b.getAttribute('data-coops-color'), upper: upper || '#181818', sole: sole || '#E9E9E7', soleHigh: sHigh || '', soleLow: sLow || '' };
    });
  }

  /* ---------------------------------------------------------- Product page */
  function initPdp(root) {
    var pdp = $('[data-coops-pdp]', root);
    if (!pdp) return;
    splitSaves(pdp);
    /* Activity pages (owner, 2026-10-21): the page's Shop buttons go all the way to the top, where the pair is bought. */
    if (pdp.classList.contains('coops-pdp--act') && !pdp.hasAttribute('data-coops-top-bound')) {
      pdp.setAttribute('data-coops-top-bound', '');
      on(document, 'click', function (e) {
        var a = e.target.closest ? e.target.closest('a[href="#shop"]') : null;
        if (!a) return;
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* Phones (owner, 2026-10-22): the description shows its first sentence with "More" right after it; "More" opens
       the rest and becomes "Show less" at its end. Computers show the whole description. */
    (function () {
      var blurb = $('.coops-pdp__blurb', pdp);
      if (!blurb || !window.matchMedia || blurb.hasAttribute('data-coops-clamp')) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var text = blurb.textContent.replace(/^\s+|\s+$/g, '');
      var cut = text.indexOf('\n');
      if (cut < 0) { var m = /[.!?。！？](\s|$)/.exec(text); cut = m ? m.index + 1 : -1; }
      /* One long sentence (activity pages): cut at a word near one line's length and show "…". */
      var ell = false;
      if ((cut < 0 || cut > 70 || cut >= text.length - 2) && text.length > 70) { cut = text.lastIndexOf(' ', 40); ell = cut > 20; if (!ell) cut = -1; }
      var first = cut > 0 ? text.slice(0, cut).replace(/\s+$/, '') : '';
      var rest = cut > 0 ? text.slice(cut).replace(/^\s+/, '') : '';
      if (!first || !rest) return;
      blurb.setAttribute('data-coops-clamp', '');
      blurb.textContent = '';
      var a = document.createElement('span'); a.textContent = first + (ell ? '…' : '');
      var r = document.createElement('span'); r.className = 'coops-pdp__blurb-rest'; r.textContent = ' ' + rest; r.hidden = true;
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'coops-pdp__more'; btn.setAttribute('aria-expanded', 'false');
      btn.textContent = T('more', 'More');
      blurb.appendChild(a); blurb.appendChild(document.createTextNode(' ')); blurb.appendChild(btn); blurb.appendChild(r);
      on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        r.hidden = !open;
        a.textContent = first + (ell && !open ? '…' : '');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? T('show_less', 'Show less') : T('more', 'More');
        if (open) { blurb.appendChild(document.createTextNode(' ')); blurb.appendChild(btn); } else { blurb.insertBefore(btn, r); }
      });
    })();

    var dataEl = $('[data-coops-pdp-variants]', pdp);
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; } }

    var main = $('[data-coops-pdp-main]', pdp);
    var colorName = $('[data-coops-pdp-colorname]', pdp);
    var qtyInput = $('[data-coops-pdp-qty]', pdp);
    var idInput = $('[data-coops-pdp-id]', pdp);
    var addBtn = $('[data-coops-pdp-add]', pdp);
    var form = $('[data-coops-pdp-form]', pdp);
    var live = $('[data-coops-live]', pdp);
    /* The header "per pair" price follows the chosen tier (design: $65 → $60 → $50); where a tier carries no price (CAD) it keeps the product price. */
    var priceMain = $('[data-coops-pdp-price]', pdp);
    var priceBase = priceMain ? priceMain.textContent.trim() : '';
    /* Preorder sale: the struck-through regular price beside it follows the tier too (data-coops-tier-was). */
    var priceWas = $('[data-coops-pdp-was]', pdp);
    var wasBase = priceWas ? priceWas.textContent.trim() : '';

    var colorBtns = $$('[data-coops-color]', pdp);
    var genderBtns = $$('[data-coops-gender]', pdp);
    var tierBtns = $$('[data-coops-tier]', pdp);
    var sizeBtns = $$('button[data-coops-size]:not([data-pair-size])', pdp);
    var thumbs = $$('[data-coops-pdp-thumb]', pdp);
    var singleOnly = $$('[data-coops-single-only]', pdp);
    var multiOnly = $$('[data-coops-multi-only]', pdp);

    /* The stars under the title go to the reviews further down the page (2026-10-14, PostHog: fewer than 1 in 5
       phone visitors scroll that far). */
    (function () {
      var stars = $('.coops-pdp__stars', pdp), rev = document.getElementById('reviews');
      if (!stars || !rev) return;
      stars.classList.add('coops-pdp__stars--link');
      stars.setAttribute('role', 'link');
      stars.setAttribute('tabindex', '0');
      var go = function (e) { if (e.target.closest('a[href]:not([href="#"])') && !e.target.closest('.coops-pdp__stars')) return; e.preventDefault(); rev.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      on(stars, 'click', go);
      on(stars, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    })();

    /* Size guide popup (2026-10-15, PostHog: shoppers tap the chart's rows and nothing happened): on the product page
       a tap on a row chooses that size in the picker — the Women's or Men's column picks that chart, the letter
       keeps the chart on show (or the other one if the letter is only there) — then the popup closes and the add
       button comes into view. A tap on the Women's / Men's heading switches the chart and goes to the sizes. */
    (function () {
      var opener = $('.coops-pdp__fit [data-coops-dialog-open]', pdp);
      var dlg = opener ? document.getElementById(opener.getAttribute('data-coops-dialog-open')) : null;
      var table = dlg ? $('.coops-sizechart__table', dlg) : null;
      if (!table) return;
      table.classList.add('coops-sizechart__table--pick');
      var GENDERS = ['Women’s', 'Men’s'];
      function genderBtn(g) { return $('.coops-gender__btn[data-coops-gender="' + g + '"]', pdp); }
      function sizeBtn(g, letter) { return sizeBtns.filter(function (b) { return b.getAttribute('data-coops-gender') === g && b.getAttribute('data-coops-size') === letter; })[0] || null; }
      function shownGender() { var b = $('.coops-gender__btn[aria-pressed="true"]', pdp); return b ? b.getAttribute('data-coops-gender') : GENDERS[0]; }
      function done(target) {
        if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
        if (target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
      }
      on(table, 'click', function (e) {
        var cell = e.target.closest('th, td');
        if (!cell) return;
        var col = Array.prototype.indexOf.call(cell.parentNode.children, cell);
        if (cell.closest('thead')) {
          if (col !== 1 && col !== 2) return;
          var gb = genderBtn(GENDERS[col - 1]);
          if (gb && gb.getAttribute('aria-pressed') !== 'true') gb.click();
          done($('.coops-sizes', pdp));
          return;
        }
        var row = cell.closest('tr');
        var head = row && row.querySelector('th');
        var letter = head ? head.textContent.trim() : '';
        if (!letter) return;
        var g = col === 1 || col === 2 ? GENDERS[col - 1] : shownGender();
        if (!sizeBtn(g, letter)) g = g === GENDERS[0] ? GENDERS[1] : GENDERS[0];
        var sb = sizeBtn(g, letter);
        if (!sb) return;
        var gb2 = genderBtn(g);
        if (gb2 && gb2.getAttribute('aria-pressed') !== 'true') gb2.click();
        if (!sb.disabled) { sb.click(); done($('[data-coops-pdp-add]', pdp)); }
        else done($('.coops-sizes', pdp));
      });
    })();

    /* Bundle line under the price (2026-10-13): the smallest and the largest bundle, worded and priced exactly as
       their pair cards print them ("2 pairs $60/pair · 4 pairs $50/pair"); a tap brings the cards into view. */
    (function () {
      var line = $('[data-coops-bundle-line]', pdp);
      var deals = line && $('[data-coops-bundle-deals]', line);
      var multi = tierBtns.filter(function (b) { return Number(b.getAttribute('data-coops-tier')) > 1; });
      if (!deals || !multi.length) return;
      if (line.hasAttribute('data-coops-ab-only') && AB !== 'B') return;
      var pick = multi.length > 1 ? [multi[0], multi[multi.length - 1]] : [multi[0]];
      var parts = pick.map(function (b) {
        var t = $('.coops-pdp__tier-title', b), p = $('.coops-pdp__tier-price b', b), u = $('.coops-pdp__tier-price span', b);
        return t && p ? t.textContent.trim() + ' ' + p.textContent.trim() + (u ? u.textContent.trim() : '') : '';
      }).filter(Boolean);
      if (!parts.length) return;
      deals.textContent = parts.join(' · ');
      line.hidden = false;
      on(line, 'click', function () {
        var tiers = $('.coops-pdp__tiers', pdp);
        if (tiers) tiers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    })();

    /* Both styles' variants and photographs for the pair builder. */
    var styleData = {};
    var styles = [];
    $$('[data-coops-style-variants]', pdp).forEach(function (el) {
      var key = el.getAttribute('data-coops-style-variants');
      var list = [];
      try { list = JSON.parse(el.textContent) || []; } catch (e) { list = []; }
      styleData[key] = list;
      styles.push({ key: key, label: el.getAttribute('data-label') || key, price: el.getAttribute('data-price') || '' });
    });
    var currentStyleKey = (function () {
      var cur = $('.coops-pdp__style.is-current', pdp);
      var name = cur ? ($('.coops-pdp__style-name', cur) || {}).textContent || '' : '';
      var hit = styles.filter(function (s) { return s.label.trim() === name.trim(); })[0];
      return hit ? hit.key : (styles[0] ? styles[0].key : 'high');
    })();
    function imageForStyle(key, color) {
      if (key === currentStyleKey) {
        var b = colorBtns.filter(function (x) { return x.getAttribute('data-coops-color') === color; })[0];
        if (b && b.getAttribute('data-image')) return b.getAttribute('data-image');
      }
      var list = styleData[key] || [];
      for (var i = 0; i < list.length; i++) if (list[i].color === color && list[i].image) return list[i].image;
      return '';
    }

    var state = {
      color: colorBtns.length ? colorBtns[0].getAttribute('data-coops-color') : '',
      gender: savedScale() || 'Men’s',
      size: '',
      qty: AB === 'B' && tierBtns.some(function (b) { return b.getAttribute('data-coops-tier') === '2'; }) ? 2 : (tierBtns.length ? Number(tierBtns[0].getAttribute('data-coops-tier')) || 1 : 1)
    };
    /* Query parameters (audit 2026-09-15):
         ?gender=womens&size=S   from the size finder: chart and size;
         ?variant=<id>           the bag's Edit link: colour, size and the chart that lists that size;
         ?edit=<line key>&qty=N  with ?variant: edit mode — the CTA replaces that line at its quantity;
         ?pairs=2|4              the home page offers: opens that tier and its builder. */
    var edit = null;
    try {
      var qs = new URLSearchParams(location.search);
      var qg = qs.get('gender'), qsz = qs.get('size');
      if (qg === 'mens' || qg === 'womens') state.gender = qg === 'mens' ? 'Men’s' : 'Women’s';
      if (qsz && sizeBtns.some(function (b) { return b.getAttribute('data-coops-size') === qsz && b.getAttribute('data-coops-gender') === state.gender && !b.disabled; })) state.size = qsz;
      var qv = Number(qs.get('variant')) || 0;
      var v0 = qv ? variants.filter(function (v) { return Number(v.id) === qv; })[0] : null;
      if (v0) {
        state.color = v0.color;
        var inChart = function (g) { return sizeBtns.some(function (b) { return b.getAttribute('data-coops-size') === v0.size && b.getAttribute('data-coops-gender') === g; }); };
        if (!inChart(state.gender)) state.gender = state.gender === 'Men’s' ? 'Women’s' : 'Men’s';
        if (inChart(state.gender)) state.size = v0.size;
      }
      var qp = Number(qs.get('pairs')) || 0;
      if (qp > 0 && tierBtns.some(function (b) { return Number(b.getAttribute('data-coops-tier')) === qp; })) state.qty = qp;
      var qk = qs.get('edit');
      if (qk && v0) edit = { key: qk, variant: qv, qty: Math.max(1, Number(qs.get('qty')) || 1), color: v0.color, size: v0.size };
    } catch (e) {}
    var editingEl = $('[data-coops-editing]', pdp);
    var errEl = $('[data-coops-pdp-error]', pdp);
    var editBusy = false;
    /* One Size guide link: it lives under the sizes and moves into the slot under the tiers while 2+ pairs are chosen. */
    var fitRow = $('.coops-pdp__fit', pdp);
    var fitHome = fitRow ? fitRow.parentNode : null;
    var fitSlot = $('[data-coops-fit-slot]', pdp);
    var tiersField = tierBtns.length ? tierBtns[0].closest('.coops-pdp__field') : null;
    if (edit) {
      pdp.setAttribute('data-coops-edit', edit.key);
      state.qty = 1;
      if (tiersField) tiersField.hidden = true;
      if (editingEl) {
        var what = $('[data-coops-editing-what]', editingEl);
        if (what) what.textContent = CN(edit.color) + ' / ' + edit.size + (edit.qty > 1 ? ' × ' + edit.qty : '');
        editingEl.hidden = false;
      }
    }
    var mainSrc = main ? main.getAttribute('src') : '';
    var builderEl = $('[data-coops-builder]', pdp);
    var builder = builderEl ? createBuilder({
      root: builderEl,
      styles: styles.length ? styles : [{ key: currentStyleKey, label: (document.querySelector('h1') || {}).textContent || '', price: '' }],
      colors: colorsFrom($('.coops-pdp__swatches', pdp) || pdp),
      tables: sizeTablesFrom($('.coops-sizes__grid--pdp', pdp) || pdp),
      variantsFor: function (key) { return key === currentStyleKey && !styleData[key] ? variants : (styleData[key] || []); },
      imageFor: imageForStyle,
      getMain: function () { return { style: currentStyleKey, color: state.color, size: state.size, gender: state.gender }; },
      qty: function () { return state.qty; },
      /* While a pair is being edited, the photograph and the six thumbnails show that pair's colour and style (owner, live 2026-09-15: the other style too). */
      onPreview: function (src, color, styleKey) { previewSrc = src || ''; previewColor = src ? (color || '') : ''; previewStyle = src ? (styleKey || '') : ''; applyMainImage(); applyThumbs(); },
      onChange: function () { render(); }
    }) : null;
    var previewSrc = '';
    var previewColor = '';
    var previewStyle = '';
    var thumbSig = '';
    /* Views on show for a colour, style and chart (Matt's brief Add 2, 2026-10-20: the order is the template's "Gallery order";
       the ad's photo, when the visit came from a matching ad, comes first). */
    function viewOn(t, col, sty, gen) {
      if (t.hasAttribute('data-coops-thumb-ad')) return true;
      var mine = t.getAttribute('data-coops-thumb-color') === col && (t.getAttribute('data-coops-thumb-style') || currentStyleKey) === sty;
      /* Worn view (owner, 2026-09-30): a men's and a women's picture follow the size chart's Men's / Women's choice;
         the worn-alt view shows the other one (a woman while Men's is chosen). */
      var tg = t.getAttribute('data-coops-thumb-gender');
      var alt = t.classList.contains('coops-pdp__thumb--worn-alt');
      if (tg && (alt ? tg === gen : tg !== gen)) mine = false;
      return mine;
    }
    var leadColor = null;
    function leadThumb(col, sty, gen) {
      /* Activity pages (owner, 2026-10-21): they open on the activity photo; another colour opens on that colour's shoe. */
      if (leadColor === null) leadColor = col;
      for (var i = 0; i < thumbs.length; i++) if (viewOn(thumbs[i], col, sty, gen) && !thumbs[i].hasAttribute('data-video') && !(col !== leadColor && thumbs[i].classList.contains('coops-pdp__thumb--act'))) return thumbs[i];
      return null;
    }
    function applyThumbs() {
      var col = previewColor || state.color;
      var sty = previewStyle || currentStyleKey;
      var gen = state.gender === 'Men’s' ? 'mens' : 'womens';
      var lead = leadThumb(col, sty, gen);
      thumbs.forEach(function (t) {
        var mine = viewOn(t, col, sty, gen);
        t.hidden = !mine;
        t.setAttribute('aria-pressed', mine && t === lead ? 'true' : 'false');
      });
      /* Phones scroll the views sideways (owner, 2026-09-27): another colour or style starts again at the side view. */
      var sig = sty + '|' + col;
      if (sig !== thumbSig) {
        thumbSig = sig;
        var strip = thumbs[0] ? thumbs[0].parentNode : null;
        if (strip && strip.scrollLeft) strip.scrollLeft = 0;
      }
      paintDots();
    }
    /* Dots on the photograph and arrows by the row (owner, 2026-10-05): both step through the views on show. */
    var dotsEl = $('[data-coops-pdp-dots]', pdp);
    function shownThumbs() { return thumbs.filter(function (t) { return !t.hidden; }); }
    function currentIndex(list) {
      for (var i = 0; i < list.length; i++) if (list[i].getAttribute('aria-pressed') === 'true') return i;
      return 0;
    }
    function paintDots() {
      if (!dotsEl) return;
      var list = shownThumbs();
      var cur = currentIndex(list);
      if (dotsEl.children.length !== list.length) {
        dotsEl.innerHTML = '';
        list.forEach(function (t, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'coops-pdp__dot';
          on(d, 'click', function () { var l = shownThumbs(); if (l[i]) showThumb(l[i]); });
          dotsEl.appendChild(d);
        });
      }
      dotsEl.hidden = list.length < 2;
      $$('.coops-pdp__dot', dotsEl).forEach(function (d, i) {
        d.setAttribute('aria-label', T('image_n', 'Image {n} of {total}', { n: i + 1, total: list.length }));
        if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    /* Views are fetched once and kept (2026-10-14, PostHog showed rage-taps on the thumbnails): the chosen view
       replaces the photograph only when it has arrived, so a slow phone never shows an empty frame, and the other
       views of the colour on show are fetched quietly after the page has loaded, so a later tap is instant. */
    var viewCache = {};
    var mainToken = 0;
    function fetchView(src) {
      if (!src) return null;
      if (!viewCache[src]) { var im = new Image(); im.decoding = 'async'; im.src = src; viewCache[src] = im; }
      return viewCache[src];
    }
    var pdpVideo = $('[data-coops-pdp-video]', pdp);
    var pdpCaption = $('[data-coops-pdp-caption]', pdp);
    function frameMode(t) {
      var vid = t ? t.getAttribute('data-video') : '';
      if (pdpVideo && main) {
        if (vid) {
          if (pdpVideo.getAttribute('src') !== vid) { pdpVideo.setAttribute('poster', t.getAttribute('data-full') || ''); pdpVideo.setAttribute('src', vid); }
          pdpVideo.hidden = false; main.hidden = true;
          var pl = pdpVideo.play(); if (pl && pl.catch) pl.catch(function () {});
        } else if (!pdpVideo.hidden) { pdpVideo.pause(); pdpVideo.hidden = true; main.hidden = false; }
      }
      if (pdpCaption) { var c = t ? t.getAttribute('data-caption') || '' : ''; pdpCaption.textContent = c; pdpCaption.hidden = !c; }
      /* One line always (owner, 2026-10-21): shrink the caption until it fits, down to 10 px. */
      if (pdpCaption && !pdpCaption.hidden) { pdpCaption.style.fontSize = ''; var fs0 = parseFloat(getComputedStyle(pdpCaption).fontSize) || 13; while (pdpCaption.scrollWidth > pdpCaption.clientWidth + 1 && fs0 > 10) { fs0 -= 0.5; pdpCaption.style.fontSize = fs0 + 'px'; } }
      var fr = main ? main.closest('[data-coops-pdp-frame]') : null;
      if (fr) { if (t && t.hasAttribute('data-cover')) fr.setAttribute('data-cover', ''); else fr.removeAttribute('data-cover'); }
    }
    function showThumb(t) {
      thumbs.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      t.setAttribute('aria-pressed', 'true');
      if (t.hasAttribute('data-video')) { mainToken++; frameMode(t); paintDots(); return; }
      if (main) {
        var src = t.getAttribute('data-full'), alt = t.getAttribute('data-alt') || '', token = ++mainToken;
        var put = function () {
          if (token !== mainToken) return;
          main.setAttribute('src', src);
          main.removeAttribute('srcset');
          main.setAttribute('alt', alt);
          frameMode(t);
        };
        var im = fetchView(src);
        if (im.complete && im.naturalWidth) put();
        else { im.addEventListener('load', put, { once: true }); im.addEventListener('error', put, { once: true }); }
      }
      /* Centre the chosen view in the row, clear of the arrows. The view on show is left out of the row (owner, 2026-10-21),
         so the row follows its neighbour: the next view on show, or the previous one at the end. */
      var strip = t.parentNode;
      var anchor = t;
      if (getComputedStyle(t).display === 'none') {
        var list = shownThumbs(), at = list.indexOf(t);
        anchor = list[at + 1] || list[at - 1] || t;
      }
      if (strip.scrollWidth > strip.clientWidth && anchor.offsetWidth) {
        var left = anchor.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
        strip.scrollTo({ left: left - (strip.clientWidth - anchor.offsetWidth) / 2, behavior: 'smooth' });
      }
      paintDots();
    }
    $$('[data-coops-pdp-step]', pdp).forEach(function (b) {
      on(b, 'click', function () {
        var list = shownThumbs();
        if (!list.length) return;
        var n = list.length;
        showThumb(list[(currentIndex(list) + Number(b.getAttribute('data-coops-pdp-step')) + n) % n]);
      });
    });
    /* The photograph shows the pair being edited, otherwise the main colour. */
    function applyMainImage() {
      if (!main) return;
      var src = previewSrc;
      var alt = '';
      var lt = null;
      if (!src) {
        lt = leadThumb(state.color, currentStyleKey, state.gender === 'Men’s' ? 'mens' : 'womens');
        if (lt) { src = lt.getAttribute('data-full'); alt = lt.getAttribute('data-alt') || ''; }
        else {
          var b = colorBtns.filter(function (x) { return x.getAttribute('data-coops-color') === state.color; })[0];
          src = b ? b.getAttribute('data-image') : '';
          alt = b ? b.getAttribute('data-alt') || '' : '';
        }
      }
      if (src && main.getAttribute('src') !== src) { mainToken++; main.setAttribute('src', src); main.removeAttribute('srcset'); if (alt) main.setAttribute('alt', alt); frameMode(lt); }
    }
    /* Warm the views of the colour on show once the page has loaded, and again whenever the colour or style changes. */
    function warmViews() { shownThumbs().forEach(function (t) { fetchView(t.getAttribute('data-full')); }); }
    var warmLater = function () { setTimeout(warmViews, 1500); };
    if (document.readyState === 'complete') warmLater(); else on(window, 'load', warmLater);
    on(pdp, 'click', function (e) { if (e.target.closest('[data-coops-color], [data-coops-style], [data-coops-gender]')) setTimeout(warmViews, 300); });

    /* The frame takes the photograph's own proportions, so nothing sits in dead space. */
    var frame = main ? main.closest('[data-coops-pdp-frame]') : null;
    // Owner (2026-09-13): the main frame keeps one size (the lead photograph's ratio, set in Liquid);
    // switching to a back view must not resize it. Only fill the ratio in when Liquid could not.
    function fitFrame() { if (frame && main && main.naturalWidth && main.naturalHeight && !frame.style.getPropertyValue('--coops-r')) frame.style.setProperty('--coops-r', (main.naturalWidth / main.naturalHeight).toFixed(4)); }
    if (main) { on(main, 'load', fitFrame); if (main.complete) fitFrame(); }
    /* Phones (2026-10-14): a sideways swipe on the photograph steps to the next or previous view, like the dots. */
    if (frame) {
      var sx = null, sy = null;
      on(frame, 'touchstart', function (e) { var p = e.touches && e.touches[0]; if (!p) return; sx = p.clientX; sy = p.clientY; }, { passive: true });
      on(frame, 'touchend', function (e) {
        var p = e.changedTouches && e.changedTouches[0];
        if (!p || sx === null) return;
        var dx = p.clientX - sx, dy = p.clientY - sy; sx = sy = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var list = shownThumbs(); if (list.length < 2) return;
        var n = list.length;
        showThumb(list[(currentIndex(list) + (dx < 0 ? 1 : -1) + n) % n]);
      }, { passive: true });
    }

    function variantFor(color, size) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].color === color && variants[i].size === size) return variants[i];
      }
      return null;
    }
    function selected() {
      var v = state.size ? variantFor(state.color, state.size) : null;
      return v && v.available ? v : null;
    }
    /* "$60" × 2 → "$120": keeps whatever currency marks wrap the number. */
    function moneyTimes(str, n) {
      var m = /^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/.exec(str || '');
      if (!m) return '';
      var v = Math.round(parseFloat(m[2].replace(/,/g, '')) * n * 100) / 100;
      return m[1] + String(v) + m[3];
    }

    function render() {
      colorBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-coops-color') === state.color ? 'true' : 'false');
      });
      applyMainImage();
      if (colorName) colorName.textContent = CN(state.color);

      genderBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-coops-gender') === state.gender ? 'true' : 'false');
      });
      var tierPrice = '';
      var tierWas = '';
      tierBtns.forEach(function (b) {
        var on = Number(b.getAttribute('data-coops-tier')) === state.qty;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { tierPrice = b.getAttribute('data-coops-tier-price') || ''; tierWas = b.getAttribute('data-coops-tier-was') || ''; }
      });
      if (priceMain) priceMain.textContent = tierPrice || priceBase;
      if (priceWas) priceWas.textContent = tierWas || wasBase;
      if (qtyInput) qtyInput.value = String(state.qty);
      paintTierHint(pdp, state.qty, tierBtns);

      var anyVariants = variants.length > 0;
      sizeBtns.forEach(function (btn) {
        btn.hidden = btn.getAttribute('data-coops-gender') !== state.gender;
        var size = btn.getAttribute('data-coops-size');
        var v = variantFor(state.color, size);
        btn.value = v ? String(v.id) : '';
        btn.disabled = !anyVariants || !v || !v.available || !PO_OK;
        var bo = paintBO(btn, v);
        var on = !btn.disabled && size === state.size;
        if (btn.type === 'submit') btn.removeAttribute('aria-pressed');
        else btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var a11y = $('[data-coops-size-a11y]', btn);
        if (a11y) {
          a11y.textContent = (btn.disabled
            ? T('size_unavailable', 'Size {size} in {color} is unavailable', { size: size, color: CN(state.color) })
            : T('select_size_n', 'Select size {size}', { size: size })) + (bo && !btn.disabled ? ', ' + BO.a11y : '');
        }
      });

      var chosen = selected();
      if (idInput) idInput.value = chosen ? String(chosen.id) : '';
      boNote(addBtn, !!(chosen && isBO(chosen.id) && !(state.qty > 1 && builder)));

      /* Gallery: only the chosen colour's views (or the colour of the pair being edited); side view pressed. */
      applyThumbs();

      /* 2+ pairs: the single controls give way to the builder. */
      var inl = !!(inline && inline.active());
      var multi = state.qty > 1 && (inl ? !inline.isSame() : (builder && builder.isMixed()));
      singleOnly.forEach(function (el) { el.hidden = !!multi; });
      multiOnly.forEach(function (el) { el.hidden = !multi; });
      if (fitRow && fitHome && fitSlot) {
        if (multi) { fitSlot.hidden = false; if (fitRow.parentNode !== fitSlot) fitSlot.appendChild(fitRow); }
        else { fitSlot.hidden = true; if (fitRow.parentNode !== fitHome) fitHome.appendChild(fitRow); }
      }
      if (builder && !inl && (state.qty > 1 || !builderEl.hidden)) builder.render(); /* same-for-all summary, or hides itself once */
      if (inl && builderEl) builderEl.hidden = true;
      if (inline) inline.paint();

      if (addBtn) {
        var need = inl ? inline.needsSize() : multi ? builder.needsSize() : !chosen;
        if (need) {
          addBtn.textContent = !PO_OK ? T('unavailable', 'Temporarily unavailable') : multi ? T('select_each', 'Select each pair’s size') : T('select_size', 'Select your size');
          if (!PO_OK) addBtn.disabled = true;
          addBtn.setAttribute('data-needs-size', 'true');
        } else if (edit) {
          addBtn.textContent = T('update_bag', 'Update bag') + (edit.qty > 1 ? ' · ' + T('n_pairs', '{n} pairs', { n: edit.qty }) : '') + ' · ' + CN(state.color) + ' / ' + state.size;
          addBtn.setAttribute('data-needs-size', 'false');
        } else if (state.qty > 1) {
          var total = tierPrice ? moneyTimes(tierPrice, state.qty) : '';
          addBtn.textContent = poWord(state.qty) + (total ? ' · ' + moneyLabel(total) : '') + tierSave(pdp);
          addBtn.setAttribute('data-needs-size', 'false');
        } else {
          addBtn.textContent = poWord(1) + ' · ' + moneyLabel(chosen.price || addBtn.getAttribute('data-price') || '');
          addBtn.setAttribute('data-needs-size', 'false');
        }
      }
    }

    colorBtns.forEach(function (b) {
      on(b, 'click', function () { state.color = b.getAttribute('data-coops-color'); render(); });
    });
    genderBtns.forEach(function (b) {
      on(b, 'click', function () {
        state.gender = b.getAttribute('data-coops-gender');
        saveScale(state.gender);
        /* A size the new chart does not list (women's 5XS; men's XL and up) would otherwise stay chosen with no pressed button to show it, and the add button would still add it (B274). */
        if (state.size && !sizeBtns.some(function (s) { return s.getAttribute('data-coops-gender') === state.gender && s.getAttribute('data-coops-size') === state.size; })) state.size = '';
        var showingWorn = main && thumbs.some(function (t) { return t.hasAttribute('data-coops-thumb-gender') && main.getAttribute('src') === t.getAttribute('data-full'); });
        render();
        /* The worn picture on show switches with the chart (owner, 2026-09-30). */
        if (showingWorn) {
          var worn = thumbs.filter(function (t) { return !t.hidden && t.classList.contains('coops-pdp__thumb--worn'); })[0];
          if (worn) showThumb(worn);
        }
      });
    });
    tierBtns.forEach(function (b) {
      on(b, 'click', function () {
        state.qty = Number(b.getAttribute('data-coops-tier')) || 1;
        render();
        if (builder && state.qty > 1) { builder.render(); render(); }
      });
    });
    sizeBtns.forEach(function (b) {
      on(b, 'click', function () {
        if (b.disabled) return;
        state.size = b.getAttribute('data-coops-size');
        render();
      });
    });
    /* Matt's brief Add 2 (2026-10-20): a visit from an ad about a use case (desk, travel, shift, gym...) opens on that
       use case's photo from the "Ways to wear" pictures. The ad name travels in utm_content / utm_campaign / utm_term
       and is kept for the visit, so the other style's page opens the same way. */
    (function adLead() {
      var base = pdp.getAttribute('data-coops-lp-base');
      var strip = thumbs[0] ? thumbs[0].parentNode : null;
      if (!base || !strip) return;
      var ctx = '';
      try {
        var q = new URLSearchParams(location.search);
        ctx = [q.get('utm_content'), q.get('utm_campaign'), q.get('utm_term')].filter(Boolean).join(' ');
        if (ctx) sessionStorage.setItem('coops_adctx', ctx); else ctx = sessionStorage.getItem('coops_adctx') || '';
      } catch (e) {}
      if (!ctx) return;
      var MAP = [
        [/desk|office|wfh|work.?from.?home|remote/i, '06'], [/travel|airport|flight|plane|trip/i, '03'],
        [/nurse|health|hospital|doctor|medical|scrubs/i, '07'], [/shift|warehouse|on.?your.?feet|standing/i, '04'],
        [/recover|post.?workout/i, '02'], [/crossfit|gym|strength|lifting|training|workout/i, '08'], [/\brun/i, '05'],
        [/yoga/i, '09'], [/pilates/i, '10'], [/gaming|gamer/i, '11'], [/teach/i, '12'],
        [/retail|hospitality|restaurant|barista|server/i, '13'], [/camp|cottage|\brv\b/i, '14'], [/ski|snowboard/i, '15'],
        [/college|dorm|student|campus/i, '16'], [/commut/i, '17'], [/gift/i, '18'], [/family|parent|\bmom|\bdad|kids/i, '19'],
        [/older|senior|grandp/i, '20'], [/dog|errand/i, '21'], [/home|house|lounge/i, '01']
      ];
      var hit = null;
      for (var i = 0; i < MAP.length; i++) if (MAP[i][0].test(ctx)) { hit = MAP[i][1]; break; }
      if (!hit) return;
      var src = base.replace('coops-lp01-g1', 'coops-lp' + hit + '-g1');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'coops-pdp__thumb coops-pdp__thumb--ad';
      b.style.setProperty('--coops-r', '1.6667');
      b.setAttribute('data-coops-pdp-thumb', '');
      b.setAttribute('data-coops-thumb-ad', '');
      b.setAttribute('data-cover', '');
      b.setAttribute('data-full', src);
      b.setAttribute('data-alt', pdp.getAttribute('data-coops-lp-alt') || '');
      b.setAttribute('aria-label', pdp.getAttribute('data-coops-lp-alt') || '');
      b.setAttribute('aria-pressed', 'false');
      var im = document.createElement('img');
      im.src = src; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
      b.appendChild(im);
      strip.insertBefore(b, strip.firstChild);
      thumbs.unshift(b);
    })();
    thumbs.forEach(function (t) {
      on(t, 'click', function () { showThumb(t); });
    });

    function nudgeToSizes() {
      var grid = $('.coops-sizes', pdp) || pdp;
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = $('button[data-coops-size]:not([disabled]):not([hidden])', pdp);
      if (live) live.textContent = T('choose_size_first', 'Choose a size first.');
      window.setTimeout(function () { if (first) first.focus(); }, 450);
    }

    if (form) {
      on(form, 'submit', function (e) {
        if (edit) {
          /* Replace the bag line being edited: add the replacement first (nothing changes if that fails), then remove the old key.
             The same variant is a no-op. A failed removal is reported on the bag page, never silent. Repeated presses are ignored while busy. */
          e.preventDefault();
          var pick = selected();
          if (!pick) { nudgeToSizes(); return; }
          if (editBusy) return;
          editBusy = true;
          var was0 = addBtn ? addBtn.textContent : '';
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = T('updating', 'Updating…'); }
          if (errEl) errEl.hidden = true;
          var r0 = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
          var H0 = { 'Content-Type': 'application/json', Accept: 'application/json' };
          var oldLabel = CN(edit.color) + ' / ' + edit.size + (edit.qty > 1 ? ' × ' + edit.qty : '');
          var newLabel = CN(state.color) + ' / ' + state.size + (edit.qty > 1 ? ' × ' + edit.qty : '');
          var done = function (msg) { try { window.sessionStorage.setItem('coops_stale_notice', msg); } catch (e2) {} location.href = r0 + 'cart'; };
          var newId = Number(pick.id);
          if (newId === edit.variant) { done(T('edit_unchanged', 'Your bag is unchanged: {old} is already in it.', { old: oldLabel })); return; }
          /* Remove the edited line by its key; if that key is gone (the bag page refreshes a line's preorder terms under a new key) fall back to the line that still holds the original variant at that quantity, then any line of that variant. Never touch the replacement just added. */
          var removeOld = function () {
            return fetch(r0 + 'cart/change.js', { method: 'POST', headers: H0, body: JSON.stringify({ id: edit.key, quantity: 0 }) }).then(function (r) {
              if (r.ok) return r;
              return fetch(r0 + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cr) { return cr.json(); }).then(function (c) {
                var lines = (c.items || []).filter(function (it) { return Number(it.variant_id) === edit.variant && it.key !== edit.newKey; });
                var hit = lines.filter(function (it) { return it.quantity === edit.qty; })[0] || lines[0];
                if (!hit) return { ok: false };
                return fetch(r0 + 'cart/change.js', { method: 'POST', headers: H0, body: JSON.stringify({ id: hit.key, quantity: 0 }) });
              });
            });
          };
          fetch(r0 + 'cart/add.js', { method: 'POST', headers: H0, body: JSON.stringify({ items: poItems(scaleItems([{ id: newId, quantity: edit.qty }], state.gender)) }) })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error((res.body && res.body.description) || T('update_error', 'Could not update your bag.'));
              var added = res.body && res.body.items ? res.body.items[0] : res.body;
              edit.newKey = added && added.key ? added.key : '';
              return removeOld().then(function (r) { return r.ok ? r : removeOld(); });
            })
            .then(function (r) {
              if (r && r.ok) done(T('edit_done', 'Bag updated: {old} is now {new}.', { old: oldLabel, 'new': newLabel }));
              else done(T('edit_partial', 'We added {new} but could not remove {old}. Please remove it below.', { old: oldLabel, 'new': newLabel }));
            })
            .catch(function (err) {
              editBusy = false;
              if (errEl) { errEl.textContent = String(err.message || err) + ' ' + T('edit_failed', 'Your bag has not been changed.'); errEl.hidden = false; }
              if (live) live.textContent = String(err.message || err);
              if (addBtn) { addBtn.disabled = false; addBtn.textContent = was0; }
            });
          return;
        }
        /* Phones: once pairs were changed in the pair panel, the page button reopens it so the bag gets exactly those pairs. */
        if (sheet && sheet.wants(state.qty)) { e.preventDefault(); sheet.open(state.qty); return; }
        var inlNow = !!(inline && inline.active());
        var multi = state.qty > 1 && (inlNow || (builder && builder.isMixed()));
        var chosen = selected();
        var items;
        if (inlNow) {
          if (inline.needsSize()) { e.preventDefault(); if (inline.isSame()) nudgeToSizes(); else { if (live) live.textContent = T('choose_each', 'Choose a size for each pair.'); var ie = inline.el(); if (ie) ie.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
          items = inline.items();
        } else if (multi) {
          if (builder.needsSize()) { e.preventDefault(); if (live) live.textContent = T('choose_each', 'Choose a size for each pair.'); builderEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          items = builder.items();
        } else {
          if (!chosen) { e.preventDefault(); nudgeToSizes(); return; }
          items = [{ id: Number(chosen.id), quantity: state.qty }];
        }
        if (!window.fetch) return; /* let the form post: id + quantity are set */
        e.preventDefault();
        var was = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T('adding', 'Adding…'); }

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: poItems(scaleItems(items, state.gender)) })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || T('add_error', 'Could not add to bag.'));
            if (live) live.textContent = multi ? T('added_n', '{n} pairs added to your bag.', { n: state.qty }) : T('added_one', '{item} added to your bag.', { item: '1 × ' + CN(state.color) + ' ' + state.size });
            if (addBtn) addBtn.textContent = T('added', 'Added');
            /* Opens the bag drawer (initDrawer listens for this). */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            refreshBagCount();
            window.setTimeout(function () { if (addBtn) addBtn.disabled = false; render(); }, 1400);
          })
          .catch(function (err) {
            if (live) live.textContent = String(err.message || err);
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = was; }
            render();
          });
      });
    }

    /* Phone pair panel (owner, 2026-10-22): on phones a tap on 2, 3 or 4 pairs slides up a panel with one compact row
       per pair (photo, High/Low, colour dots, size dropdown), filled in from the page's own pick, and one button that
       adds the pairs and opens the bag. Pairs 2+ follow pair 1 until they are changed. Swipe down, a tap outside or the
       phone's back button closes it. Computers keep the builder on the page. */
    var sheet = (function () {
      if (edit || !builder || !window.matchMedia || !window.fetch) return null;
      var mq = window.matchMedia('(max-width: 749px)');
      var colors = colorsFrom($('.coops-pdp__swatches', pdp) || pdp);
      var tables = sizeTablesFrom($('.coops-sizes__grid--pdp', pdp) || pdp);
      var styleList = styles.length ? styles : [{ key: currentStyleKey, label: '' }];
      var pairs = [], touched = [], el = null, histPushed = false, busy = false, lockY = 0;
      function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
      function listFor(key) { return key === currentStyleKey && !styleData[key] ? variants : (styleData[key] || []); }
      function vFor(c) { var l = listFor(c.style); for (var i = 0; i < l.length; i++) if (l[i].color === c.color && l[i].size === c.size) return l[i]; return null; }
      function shortStyle(s) { return String(s.label || s.key).replace(/\s*top$/i, '') || s.key; }
      function main0() { return { style: currentStyleKey, color: state.color, gender: state.gender, size: state.size }; }
      /* Option 2 (owner, 2026-10-22): sizes are a row of tiles you swipe sideways (an arrow and a fade say there are
         more), "Same size for all pairs" (on by default) shows one shared row, otherwise each pair has its own; the
         2 / 3 / 4 choice sits in the panel's top row; colour dots sit under each shoe. Four pairs fit without scrolling. */
      var same = true;
      function build() {
        el = document.createElement('div');
        el.className = 'coops-psheet coops-psheet--v2';
        el.hidden = true;
        el.innerHTML = '<div class="coops-psheet__scrim" data-psheet-close></div>' +
          '<div class="coops-psheet__panel" role="dialog" aria-modal="true" aria-labelledby="coops-psheet-title">' +
          '<div class="coops-psheet__grab" data-psheet-grab><span></span></div>' +
          '<div class="coops-psheet__head" data-psheet-grab><h2 class="coops-psheet__title coops-visually-hidden" id="coops-psheet-title"></h2>' +
          '<div class="coops-psheet__qty" role="group" aria-label="' + esc((($('.coops-pdp__tiers', pdp) || { getAttribute: function () { return ''; } }).getAttribute('aria-label')) || '') + '" data-psheet-qtys></div>' +
          '<button type="button" class="coops-psheet__x" data-psheet-close aria-label="' + esc(T('close', 'Close')) + '">×</button></div>' +
          '<div class="coops-psheet__same" data-psheet-samebox></div>' +
          '<ol class="coops-psheet__list" data-psheet-list></ol>' +
          '<div class="coops-psheet__foot"><button type="button" class="coops-btn coops-btn--primary coops-btn--block coops-psheet__add" data-psheet-add></button>' +
          '<p class="coops-psheet__ship" data-psheet-ship hidden></p>' +
          '<p class="coops-psheet__msg" role="status" aria-live="polite" data-psheet-msg></p></div></div>';
        document.body.appendChild(el);
        on(el, 'click', onClick);
        swipe();
      }
      function chartRows(g) { return g === 'Women’s' ? tables.womens : tables.mens; }
      function genderSwitch(g, target) {
        var h = '<div class="coops-psheet__genders" role="group" aria-label="' + esc(T('size_chart', 'Size chart')) + '" data-psheet-target="' + target + '">';
        ['Men’s', 'Women’s'].forEach(function (x) { h += '<button type="button" data-psheet-gender="' + x + '" aria-pressed="' + (x === g ? 'true' : 'false') + '">' + esc(GN(x)) + '</button>'; });
        return h + '</div>';
      }
      /* One row of size tiles. target is a pair number, or "all" for the shared row (a size is offered there when every pair has it). */
      function sizeRow(g, size, target, label) {
        var list = target === 'all' ? pairs : [pairs[target]];
        var h = '<div class="coops-psheet__scroller" data-psheet-target="' + target + '"><div class="coops-psheet__chips" role="group" aria-label="' + esc(label) + '">';
        chartRows(g).forEach(function (r) {
          var ok = PO_OK, po = false;
          list.forEach(function (c) { var v = vFor({ style: c.style, color: c.color, size: r[0] }); if (!(v && v.available)) ok = false; else if (isBO(v.id)) po = true; });
          var on = r[0] === size && ok;
          h += '<button type="button" class="coops-psheet__chip' + (po ? ' is-po' : '') + '" data-psheet-chip="' + esc(r[0]) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (ok ? '' : ' disabled') +
            ' aria-label="' + esc(GN(g) + ' ' + r[0] + (r[1] ? ' (' + r[1] + ')' : '') + (po ? ', ' + (BO.badge || 'Preorder') : '')) + '"><b>' + esc(r[1] || r[0]) + '</b><small>' + esc(r[0]) + '</small></button>';
        });
        return h + '</div><button type="button" class="coops-psheet__more" data-psheet-more aria-label="' + esc(T('more_sizes', 'More sizes')) + '">›</button></div>';
      }
      function paint() {
        if (!el) return;
        var q = pairs.length;
        $('#coops-psheet-title', el).textContent = T('your_n_pairs', 'Your {n} pairs', { n: q });
        /* 2 / 3 / 4 pairs, as the page's pair boxes word and price them, so the number changes without closing the panel. */
        var qh = '';
        tierBtns.forEach(function (tb) {
          var n = Number(tb.getAttribute('data-coops-tier')) || 1;
          if (n < 2) return;
          var tt = $('.coops-pdp__tier-title', tb), pb = $('.coops-pdp__tier-price b', tb), pu = $('.coops-pdp__tier-price span', tb);
          qh += '<button type="button" data-psheet-qty="' + n + '" aria-pressed="' + (n === q ? 'true' : 'false') + '"><b>' + esc(tt ? tt.textContent.trim() : String(n)) + '</b>' + (pb ? '<span>' + esc(pb.textContent.trim() + (pu ? pu.textContent.trim() : '')) + '</span>' : '') + '</button>';
        });
        $('[data-psheet-qtys]', el).innerHTML = qh;
        /* "Free shipping · Save $10" under the button; the saving alone where shipping is not free. */
        var shipEl = $('[data-psheet-ship]', el), shipSrc = $('.coops-pdp__tier-ship', pdp);
        var shipTxt = [shipSrc ? shipSrc.textContent.trim() : '', tierSave(pdp).replace(/^ · /, '')].filter(Boolean).join(' · ');
        if (shipEl) { shipEl.textContent = shipTxt; shipEl.hidden = !shipTxt; }
        /* Same size for all pairs: one switch and one row of sizes for every pair. */
        var c0 = pairs[0];
        var sh = '<div class="coops-psheet__samehead"><button type="button" class="coops-psheet__check" data-psheet-same aria-pressed="' + (same ? 'true' : 'false') + '"><i aria-hidden="true"></i>' + esc(T('same_size_all', 'Same size for all pairs')) + '</button>' + (same ? genderSwitch(c0.gender, 'all') : '') + '</div>';
        if (same) sh += sizeRow(c0.gender, c0.size, 'all', T('size', 'Size')) + '<p class="coops-psheet__hint">' + esc(T('swipe_sizes', 'Swipe for more sizes')) + ' →</p>';
        var sameBox = $('[data-psheet-samebox]', el);
        sameBox.innerHTML = sh;
        sameBox.classList.toggle('is-on', same);
        var h = '';
        pairs.forEach(function (c, i) {
          var img = imageForStyle(c.style, c.color) || '';
          h += '<li class="coops-psheet__pair" data-psheet-pair="' + i + '">';
          h += '<span class="coops-psheet__fig"><span class="coops-psheet__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" decoding="async">' : '') + '<b>' + (i + 1) + '</b></span>';
          h += '<span class="coops-psheet__dots" role="group" aria-label="' + esc(T('colour', 'Colour')) + '">';
          colors.forEach(function (col) {
            h += '<button type="button" class="coops-psheet__dot" data-psheet-color="' + esc(col.name) + '" aria-pressed="' + (col.name === c.color ? 'true' : 'false') + '" aria-label="' + esc(CN(col.name)) + '" style="background:linear-gradient(180deg,' + esc(col.upper) + ' 0 55%,' + esc((c.style === 'low' ? col.soleLow : col.soleHigh) || col.sole) + ' 55% 100%)"></button>';
          });
          h += '</span></span><div class="coops-psheet__opts"><div class="coops-psheet__row">';
          if (styleList.length > 1) {
            h += '<div class="coops-psheet__styles" role="group" aria-label="' + esc(T('style', 'Style')) + '">';
            styleList.forEach(function (s) { h += '<button type="button" data-psheet-style="' + esc(s.key) + '" aria-pressed="' + (s.key === c.style ? 'true' : 'false') + '">' + esc(shortStyle(s)) + '</button>'; });
            h += '</div>';
          }
          if (!same) h += genderSwitch(c.gender, String(i));
          h += '</div>';
          if (!same) h += sizeRow(c.gender, c.size, i, T('pair_n', 'Pair {n}', { n: i + 1 }) + ' · ' + T('size', 'Size'));
          h += '</div></li>';
        });
        $('[data-psheet-list]', el).innerHTML = h;
        /* Each row opens on its chosen size; the arrow goes once the row's end is in view. */
        $$('.coops-psheet__scroller', el).forEach(function (sc) {
          var row = $('.coops-psheet__chips', sc), on1 = $('[aria-pressed="true"]', row);
          if (on1) row.scrollLeft = Math.max(0, on1.offsetLeft - (row.clientWidth - on1.offsetWidth) / 2);
          var ends = function () { sc.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4); };
          ends();
          row.addEventListener('scroll', ends, { passive: true });
        });
        var btn = $('[data-psheet-add]', el);
        var need = pairs.some(function (c) { var v = vFor(c); return !v || !v.available; });
        if (busy) return;
        btn.disabled = !PO_OK;
        if (!PO_OK) btn.textContent = T('unavailable', 'Temporarily unavailable');
        else if (need) { btn.textContent = T('select_each', 'Select each pair’s size'); btn.setAttribute('data-needs-size', 'true'); }
        else {
          var tb = tierBtns.filter(function (b) { return Number(b.getAttribute('data-coops-tier')) === q; })[0];
          var tp = tb ? tb.getAttribute('data-coops-tier-price') || '' : '';
          var total = tp ? moneyTimes(tp, q) : '';
          btn.textContent = poWord(q) + (total ? ' · ' + moneyLabel(total) : '') + tierSave(pdp);
          btn.setAttribute('data-needs-size', 'false');
        }
      }
      /* Pair 1 is the page's own pick: keep the page in step while it is the same style. */
      function syncPage() { if (pairs[0] && pairs[0].style === currentStyleKey) { state.color = pairs[0].color; state.gender = pairs[0].gender; state.size = pairs[0].size; render(); } }
      function setPair(i, patch) {
        pairs[i] = Object.assign({}, pairs[i], patch);
        if (i === 0) { for (var k = 1; k < pairs.length; k++) if (!touched[k]) pairs[k] = Object.assign({}, pairs[0]); syncPage(); }
        else touched[i] = true;
        if (same) for (var j = 1; j < pairs.length; j++) { pairs[j].gender = pairs[0].gender; pairs[j].size = pairs[0].size; }
        paint();
      }
      function setAll(patch) {
        pairs.forEach(function (c, k) { pairs[k] = Object.assign({}, c, patch); });
        syncPage();
        paint();
      }
      function onClick(e) {
        var t = e.target.closest('[data-psheet-close], [data-psheet-qty], [data-psheet-same], [data-psheet-more], [data-psheet-chip], [data-psheet-style], [data-psheet-color], [data-psheet-gender], [data-psheet-add]');
        if (!t) return;
        if (t.hasAttribute('data-psheet-qty')) { var nq = Number(t.getAttribute('data-psheet-qty')); if (nq !== pairs.length) { state.qty = nq; render(); open(nq); } return; }
        if (t.hasAttribute('data-psheet-close')) { close(); return; }
        if (t.hasAttribute('data-psheet-add')) { add(); return; }
        if (t.hasAttribute('data-psheet-same')) {
          same = !same;
          if (same) setAll({ gender: pairs[0].gender, size: pairs[0].size }); else paint();
          return;
        }
        if (t.hasAttribute('data-psheet-more')) { var row = $('.coops-psheet__chips', t.closest('.coops-psheet__scroller')); row.scrollBy({ left: row.clientWidth * 0.7, behavior: 'smooth' }); return; }
        var holder = t.closest('[data-psheet-target]');
        var target = holder ? holder.getAttribute('data-psheet-target') : null;
        if (t.hasAttribute('data-psheet-chip')) {
          if (t.disabled) return;
          if (target === 'all') setAll({ size: t.getAttribute('data-psheet-chip') });
          else setPair(Number(target), { size: t.getAttribute('data-psheet-chip') });
          return;
        }
        if (t.hasAttribute('data-psheet-gender')) {
          /* A size the other chart does not list (women's 5XS; men's XL and up) is cleared. */
          var g = t.getAttribute('data-psheet-gender'), rows = chartRows(g);
          if (target === 'all') { var ks = rows.some(function (r) { return r[0] === pairs[0].size; }); setAll({ gender: g, size: ks ? pairs[0].size : '' }); return; }
          var gi = Number(target), keepSize = rows.some(function (r) { return r[0] === pairs[gi].size; });
          setPair(gi, { gender: g, size: keepSize ? pairs[gi].size : '' });
          return;
        }
        var pe = t.closest('[data-psheet-pair]');
        if (!pe) return;
        var i = Number(pe.getAttribute('data-psheet-pair'));
        if (t.hasAttribute('data-psheet-style')) setPair(i, { style: t.getAttribute('data-psheet-style') });
        else setPair(i, { color: t.getAttribute('data-psheet-color') });
      }
      function swipe() {
        var panel = $('.coops-psheet__panel', el), y0 = null, dy = 0;
        $$('[data-psheet-grab]', el).forEach(function (g) {
          on(g, 'touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
          on(g, 'touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
          on(g, 'touchend', function () { if (y0 === null) return; y0 = null; panel.style.transition = ''; panel.style.transform = ''; if (dy > 70) close(); });
        });
      }
      function onPop() { if (el && !el.hidden) { histPushed = false; close(true); } }
      function open(q) {
        if (!el) build();
        /* Pair 1 is the page's pick (or what was chosen here before the panel was closed); the others follow it unless changed. */
        var keep = pairs;
        var p0 = keep[0] && keep[0].style !== currentStyleKey ? keep[0] : main0();
        var nt = [];
        pairs = [];
        for (var i = 0; i < q; i++) {
          var mine = i > 0 && keep[i] && touched[i];
          pairs.push(Object.assign({}, mine ? keep[i] : p0));
          nt.push(!!mine);
        }
        touched = nt;
        $('[data-psheet-msg]', el).textContent = '';
        paint();
        el.hidden = false;
        /* iPhone Safari scrolls the page behind a panel even with overflow hidden (owner's screen recording, 2026-10-23):
           pin the page where it is while the panel is open and put it back on close. */
        if (!document.documentElement.classList.contains('coops-psheet-open')) {
          lockY = window.scrollY || window.pageYOffset || 0;
          var bs = document.body.style; bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
        }
        document.documentElement.classList.add('coops-psheet-open');
        requestAnimationFrame(function () { el.classList.add('is-open'); });
        if (!histPushed) { try { history.pushState({ coopsSheet: 1 }, ''); histPushed = true; } catch (e) {} }
        var ttl = $('#coops-psheet-title', el);
        ttl.setAttribute('tabindex', '-1');
        try { ttl.focus({ preventScroll: true }); } catch (e) {}
      }
      function close(fromPop) {
        if (!el || el.hidden) return;
        el.classList.remove('is-open');
        document.documentElement.classList.remove('coops-psheet-open');
        var bs2 = document.body.style; bs2.position = ''; bs2.top = ''; bs2.left = ''; bs2.right = ''; bs2.width = '';
        /* Put the page back where it was; again after the back step, which restores its own (pinned) scroll position. */
        var y = lockY, back = function () { try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); } };
        back(); setTimeout(back, 60); setTimeout(back, 250);
        window.setTimeout(function () { el.hidden = true; }, 220);
        if (!fromPop && histPushed) { histPushed = false; try { history.back(); } catch (e) {} }
      }
      function add() {
        var btn = $('[data-psheet-add]', el), msg = $('[data-psheet-msg]', el);
        if (busy) return;
        if (btn.getAttribute('data-needs-size') === 'true') {
          msg.textContent = T('choose_each', 'Choose a size for each pair.');
          var miss = $('.coops-psheet__chips', el);
          if (miss) try { miss.scrollIntoView({ block: 'nearest' }); var f = $('button:not([disabled])', miss); if (f) f.focus({ preventScroll: true }); } catch (e) {}
          return;
        }
        var by = {};
        pairs.forEach(function (c) {
          var v = vFor(c); if (!v) return;
          var k = v.id + '|' + c.gender;
          if (!by[k]) by[k] = { id: Number(v.id), quantity: 0, properties: { _size_scale: c.gender === 'Women’s' ? "Women's" : "Men's" } };
          by[k].quantity++;
        });
        var items = Object.keys(by).map(function (k) { return by[k]; });
        busy = true; btn.disabled = true; var was = btn.textContent; btn.textContent = T('adding', 'Adding…');
        var r0 = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        fetch(r0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: poItems(scaleItems(items, state.gender)) }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || T('add_error', 'Could not add to bag.'));
            if (live) live.textContent = T('added_n', '{n} pairs added to your bag.', { n: pairs.length });
            busy = false; btn.disabled = false;
            pairs = []; touched = []; same = true;
            close();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            refreshBagCount();
          })
          .catch(function (err) { busy = false; btn.disabled = false; btn.textContent = was; msg.textContent = String(err.message || err); });
      }
      on(window, 'popstate', onPop);
      return {
        open: function (q) { if (mq.matches && q > 1) open(q); }, close: close,
        wants: function (q) { return mq.matches && q > 1 && (touched.some(Boolean) || (pairs[0] && pairs[0].style !== currentStyleKey)); }
      };
    })();
    /* Computers (owner, 2026-10-22): the pairs are set up under the pair boxes, like the phone panel but inline.
       "Same size for all pairs" (on by default) uses the page's own size grid; unticked, each pair gets its own
       Men's / Women's switch and size tiles. Every pair has its photo, colour dots and Low / High. */
    var inline = (function () {
      if (edit || !builderEl || !window.matchMedia) return null;
      var mq = window.matchMedia('(min-width: 750px)');
      var colors = colorsFrom($('.coops-pdp__swatches', pdp) || pdp);
      var tables = sizeTablesFrom($('.coops-sizes__grid--pdp', pdp) || pdp);
      var styleList = styles.length ? styles : [{ key: currentStyleKey, label: '' }];
      var pairs = [], touched = [], same = true, el = null;
      function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
      function listFor(key) { return key === currentStyleKey && !styleData[key] ? variants : (styleData[key] || []); }
      function vFor(c) { var l = listFor(c.style); for (var i = 0; i < l.length; i++) if (l[i].color === c.color && l[i].size === c.size) return l[i]; return null; }
      function shortStyle(s) { return String(s.label || s.key).replace(/\s*top$/i, '') || s.key; }
      function chartRows(g) { return g === 'Women’s' ? tables.womens : tables.mens; }
      function active() { return mq.matches && state.qty > 1; }
      /* The pairs follow the page: pair 1 is the page's pick, the others copy it until changed; with "same size" every
         pair takes the page's size and chart. */
      function sync() {
        var q = state.qty, m = { style: currentStyleKey, color: state.color, gender: state.gender, size: state.size };
        var keep = pairs, nt = [];
        pairs = [];
        for (var i = 0; i < q; i++) {
          var mine = i > 0 && keep[i] && touched[i];
          var c = Object.assign({}, mine ? keep[i] : (i === 0 && keep[0] && keep[0].style !== currentStyleKey ? keep[0] : m));
          if (i === 0 && !(keep[0] && keep[0].style !== currentStyleKey)) { c.color = m.color; c.style = m.style; }
          if (same) { c.size = m.size; c.gender = m.gender; }
          pairs.push(c); nt.push(!!mine);
        }
        touched = nt;
      }
      function build() {
        el = document.createElement('div');
        el.className = 'coops-pinline';
        builderEl.parentNode.insertBefore(el, builderEl);
        on(el, 'click', onClick);
      }
      function chipsFor(c, i) {
        var h = '<div class="coops-pinline__sizes" role="group" aria-label="' + esc(T('pair_n', 'Pair {n}', { n: i + 1 }) + ' · ' + T('size', 'Size')) + '">';
        chartRows(c.gender).forEach(function (r) {
          var v = vFor({ style: c.style, color: c.color, size: r[0] });
          var ok = !!(v && v.available && PO_OK), po = ok && isBO(v.id);
          h += '<button type="button" class="coops-psheet__chip' + (po ? ' is-po' : '') + '" data-pi-size="' + esc(r[0]) + '" aria-pressed="' + (ok && r[0] === c.size ? 'true' : 'false') + '"' + (ok ? '' : ' disabled') + ' aria-label="' + esc(GN(c.gender) + ' ' + r[0] + (r[1] ? ' (' + r[1] + ')' : '') + (po ? ', ' + (BO.badge || 'Preorder') : '')) + '"><b>' + esc(r[1] || r[0]) + '</b><small>' + esc(r[0]) + '</small></button>';
        });
        return h + '</div>';
      }
      function paint() {
        if (!active()) { if (el) el.hidden = true; pdp.classList.remove('has-pinline'); return; }
        if (!el) build();
        sync();
        pdp.classList.add('has-pinline');
        el.hidden = false;
        var h = '<div class="coops-pinline__top"><span class="coops-pinline__title">' + esc(T('your_n_pairs', 'Your {n} pairs', { n: pairs.length })) + '</span>' +
          '<button type="button" class="coops-psheet__check" data-pi-same aria-pressed="' + (same ? 'true' : 'false') + '"><i aria-hidden="true"></i>' + esc(T('same_size_all', 'Same size for all pairs')) + '</button></div><ol class="coops-pinline__list">';
        pairs.forEach(function (c, i) {
          var img = imageForStyle(c.style, c.color) || '';
          h += '<li class="coops-pinline__pair" data-pi-pair="' + i + '"><span class="coops-psheet__fig"><span class="coops-psheet__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" decoding="async">' : '') + '<b>' + (i + 1) + '</b></span>';
          h += '<span class="coops-psheet__dots" role="group" aria-label="' + esc(T('colour', 'Colour')) + '">';
          colors.forEach(function (col) {
            h += '<button type="button" class="coops-psheet__dot" data-pi-color="' + esc(col.name) + '" aria-pressed="' + (col.name === c.color ? 'true' : 'false') + '" aria-label="' + esc(CN(col.name)) + '" style="background:linear-gradient(180deg,' + esc(col.upper) + ' 0 55%,' + esc((c.style === 'low' ? col.soleLow : col.soleHigh) || col.sole) + ' 55% 100%)"></button>';
          });
          h += '</span></span><div class="coops-pinline__opts"><div class="coops-psheet__row">';
          if (styleList.length > 1) {
            h += '<div class="coops-psheet__styles" role="group" aria-label="' + esc(T('style', 'Style')) + '">';
            /* Computers (owner, 2026-10-23): full names, High Top first. */
            styleList.slice().sort(function (x, y) { return (x.key === 'high' ? 0 : 1) - (y.key === 'high' ? 0 : 1); }).forEach(function (s) { h += '<button type="button" data-pi-style="' + esc(s.key) + '" aria-pressed="' + (s.key === c.style ? 'true' : 'false') + '">' + esc(s.label || shortStyle(s)) + '</button>'; });
            h += '</div>';
          }
          if (!same) {
            h += '<div class="coops-psheet__genders" role="group" aria-label="' + esc(T('size_chart', 'Size chart')) + '">';
            ['Men’s', 'Women’s'].forEach(function (g) { h += '<button type="button" data-pi-gender="' + g + '" aria-pressed="' + (g === c.gender ? 'true' : 'false') + '">' + esc(GN(g)) + '</button>'; });
            h += '</div>';
          } else {
            var v0 = vFor(c);
            h += '<span class="coops-pinline__meta">' + esc(CN(c.color)) + (v0 && v0.available ? ' · ' + esc(GN(c.gender)) + ' ' + esc(c.size) : '') + '</span>';
          }
          h += '</div>' + (same ? '' : chipsFor(c, i)) + '</div></li>';
        });
        el.innerHTML = h + '</ol>';
      }
      function setPair(i, patch) {
        pairs[i] = Object.assign({}, pairs[i], patch);
        if (i === 0) {
          for (var k = 1; k < pairs.length; k++) if (!touched[k]) pairs[k] = Object.assign({}, pairs[k], { color: pairs[0].color, style: pairs[0].style }, same ? {} : { size: pairs[0].size, gender: pairs[0].gender });
          /* Pair 1 is the page's own pick: keep the page in step while it is the same style. */
          if (pairs[0].style === currentStyleKey) { state.color = pairs[0].color; if (!same) { state.gender = pairs[0].gender; state.size = pairs[0].size; } }
        } else touched[i] = true;
        render();
      }
      function onClick(e) {
        var t = e.target.closest('[data-pi-same], [data-pi-size], [data-pi-style], [data-pi-color], [data-pi-gender]');
        if (!t) return;
        if (t.hasAttribute('data-pi-same')) {
          same = !same;
          if (same) pairs.forEach(function (c, k) { pairs[k] = Object.assign({}, c, { size: state.size, gender: state.gender }); });
          render();
          return;
        }
        var i = Number(t.closest('[data-pi-pair]').getAttribute('data-pi-pair'));
        if (t.hasAttribute('data-pi-size')) { if (!t.disabled) setPair(i, { size: t.getAttribute('data-pi-size') }); return; }
        if (t.hasAttribute('data-pi-gender')) {
          var g = t.getAttribute('data-pi-gender'), keepSize = chartRows(g).some(function (r) { return r[0] === pairs[i].size; });
          setPair(i, { gender: g, size: keepSize ? pairs[i].size : '' });
          return;
        }
        if (t.hasAttribute('data-pi-style')) setPair(i, { style: t.getAttribute('data-pi-style') });
        else setPair(i, { color: t.getAttribute('data-pi-color') });
      }
      function needsSize() { sync(); return pairs.some(function (c) { var v = vFor(c); return !v || !v.available; }); }
      function items() {
        sync();
        var by = {};
        pairs.forEach(function (c) {
          var v = vFor(c); if (!v) return;
          var k = v.id + '|' + c.gender;
          if (!by[k]) by[k] = { id: Number(v.id), quantity: 0, properties: { _size_scale: c.gender === 'Women’s' ? "Women's" : "Men's" } };
          by[k].quantity++;
        });
        return Object.keys(by).map(function (k) { return by[k]; });
      }
      if (mq.addEventListener) mq.addEventListener('change', function () { render(); });
      return { active: active, isSame: function () { return same; }, paint: paint, needsSize: needsSize, items: items, el: function () { return el; } };
    })();

    if (sheet) tierBtns.forEach(function (b) {
      on(b, 'click', function () { if (state.qty > 1) sheet.open(state.qty); });
    });

    /* Phones (owner, 2026-10-22): the star rating sits in the top-left corner of the main photo. */
    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var stars = $('.coops-pdp__buy > .coops-pdp__stars', pdp), frame = $('[data-coops-pdp-frame]', pdp);
      if (!stars || !frame) return;
      stars.classList.add('coops-pdp__stars--photo');
      frame.appendChild(stars);
    })();

    /* Phones (owner, 2026-10-22): "Size guide" sits next to the word SIZE; the fit line stays right under it (CSS). Moved after
       the size-guide script above has found the link, so the popup and its row picking keep working. */
    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var row = $('#size .coops-pdp__label-row', pdp), label = row && $('.coops-pdp__label', row);
      var guide = $('#size .coops-pdp__fit a[data-coops-dialog-open]', pdp);
      if (!row || !label || !guide) return;
      guide.classList.add('coops-pdp__guide');
      label.parentNode.insertBefore(guide, label.nextSibling);
    })();

    if (builder && state.qty > 1) builder.render(); /* ?pairs=2|4: the builder rows, as a tier click would */
    render();
  }

  /* ------------------------------------------------------------- Bag count */
  function refreshBagCount() {
    if (!window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-coops-bag-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          var btn = el.closest('[data-coops-bag]');
          if (btn) btn.setAttribute('aria-label', cart.item_count === 1 ? T('open_bag_one', 'Open bag, 1 item') : T('open_bag_n', 'Open bag, {n} items', { n: cart.item_count }));
        });
      })
      .catch(function () { /* leave the server-rendered count */ });
  }

  /* --------------------------------------------------------------- Dialogs */
  function initDialogs(root) {
    $$('[data-coops-dialog-open]', root).forEach(function (btn) {
      var dlg = document.getElementById(btn.getAttribute('data-coops-dialog-open'));
      if (!dlg) return;
      on(btn, 'click', function (e) {
        if (e && e.preventDefault) e.preventDefault();
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
        /* Focus the panel itself, not the close button, so a tap does not leave a focus ring on the × (keyboard users still reach it with Tab). */
        var panel = dlg.querySelector('.coops-modal__inner');
        if (panel) { panel.setAttribute('tabindex', '-1'); try { panel.focus({ preventScroll: true }); } catch (err) { panel.focus(); } }
      });
      $$('[data-coops-dialog-close]', dlg).forEach(function (c) {
        on(c, 'click', function () {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      });
      /* click outside the panel closes */
      on(dlg, 'click', function (e) { if (e.target === dlg) dlg.close(); });
    });
  }


  /* ------------------------------------------------------------ Tab strips */
  /* [data-coops-tabs]: real role=tab buttons + role=tabpanel panels. Arrow
     keys move between tabs (roving tabindex), Home/End jump, and only the
     selected panel is un-hidden. */
  function initTabs(root) {
    $$('[data-coops-tabs]', root).forEach(function (wrap) {
      var tabs = $$('[data-coops-tab]', wrap);
      var panels = $$('[data-coops-panel]', wrap);
      if (!tabs.length || tabs.length !== panels.length) return;

      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var onTab = i === j;
          t.setAttribute('aria-selected', onTab ? 'true' : 'false');
          t.tabIndex = onTab ? 0 : -1;
          panels[j].hidden = !onTab;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { select(i, false); });
        on(t, 'keydown', function (e) {
          var n = i;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          else return;
          e.preventDefault();
          select(n, true);
        });
      });
    });
  }

  /* ------------------------------------------------------------ Bag drawer */
  /* The drawer is a Liquid section. Every cart change re-renders it through
     the Section Rendering API and swaps the panel, so the lines, savings,
     shipping row and wallet buttons are whatever Shopify says they are. */
  var DRAWER_SECTION = 'coops-cart-drawer';
  var refreshing = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  /* ...and bring them up to date for the bag as it now is: the bag page (/cart) is a page render, so it carries every
     wallet the bag qualifies for (an empty bag gets no Google Pay, for one). Only the buttons are taken from it. */
  var walletsSeq = 0;
  function refreshWallets() {
    var box = $('[data-coops-drawer-panel] [data-coops-wallets]');
    if (!box || box.hidden) return;
    var seq = ++walletsSeq;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        if (!h || seq !== walletsSeq) return;
        var t = document.createElement('div'); t.innerHTML = h;
        var src = $('.coops-cartpage__wallets', t), now = $('[data-coops-drawer-panel] [data-coops-wallets]');
        if (!src || !now || !src.innerHTML.trim()) return;
        var names = function (el) { return (el.innerHTML.match(/name&quot;:&quot;[a-z_]+|"name":"[a-z_]+/g) || []).join(); };
        if (names(src) !== names(now)) now.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }
  function refreshDrawer(openAfter) {
    if (refreshing) return refreshing;
    var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + '?sections=' + DRAWER_SECTION;
    /* no-store: never an old copy of the bag from the browser cache (a page restored with Back showed a removed pair). */
    refreshing = fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json[DRAWER_SECTION];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-coops-drawer-panel]', tmp);
        var current = $('[data-coops-drawer-panel]');
        /* Keep the express-checkout buttons from the page render: the refresh only carries Shop Pay (2026-10-16). */
        var oldW = current && $('[data-coops-wallets]', current), newW = fresh && $('[data-coops-wallets]', fresh);
        /* Page rendered with an empty bag: the buttons waited in a <template> (speed, 2026-10-21); put them on the page now. */
        var tpl = current && $('[data-coops-wallets-tpl]', current);
        if (oldW && tpl && !oldW.children.length && newW && !newW.hidden) oldW.appendChild(tpl.content.cloneNode(true));
        if (oldW && newW) { oldW.hidden = newW.hidden; newW.replaceWith(oldW); }
        if (fresh && current) current.replaceWith(fresh);
        refreshWallets();
        var count = $('[data-coops-bag-count]', tmp);
        if (count) $$('[data-coops-bag-count]').forEach(function (el) { el.textContent = count.textContent; });
        initDrawerPanel(document);
        if (openAfter) openDrawer();
      })
      .catch(function () {})
      .then(function () { refreshing = null; });
    return refreshing;
  }

  /* The bag's 2nd-pair card (snippets/coops-cart-pair2, Matt's brief Fix 3, 2026-10-16): "Add a 2nd pair" opens a
     style / colour / size picker that starts on the pair already in the bag; Add puts that pair in and the bag
     re-renders with the bundle price and free shipping. One listener for the drawer and the bag page, since the
     drawer's HTML is replaced after every change. */
  function pair2Paint(card, keep) {
    var data; try { data = JSON.parse(($('[data-coops-pair2-data]', card) || {}).textContent || '{}'); } catch (e) { return; }
    if (!data.products) return;
    var sS = $('[data-pair2-style]', card), sC = $('[data-pair2-color]', card), sZ = $('[data-pair2-size]', card);
    var want = keep ? { product: sS.value, color: sC.value, size: sZ.value } : data.start;
    var prod = data.products.filter(function (p) { return p.handle === want.product; })[0] || data.products[0];
    var opt = function (v, label, dis) { var o = document.createElement('option'); o.value = v; o.textContent = label; if (dis) o.disabled = true; return o; };
    sS.innerHTML = ''; data.products.forEach(function (p) { sS.appendChild(opt(p.handle, p.title)); }); sS.value = prod.handle;
    var colors = []; prod.variants.forEach(function (v) { if (colors.indexOf(v.color) < 0) colors.push(v.color); });
    var color = colors.indexOf(want.color) > -1 ? want.color : colors[0];
    sC.innerHTML = ''; colors.forEach(function (c) { sC.appendChild(opt(c, CN(c))); }); sC.value = color;
    var rows = prod.variants.filter(function (v) { return v.color === color; });
    sZ.innerHTML = '';
    rows.forEach(function (v) { sZ.appendChild(opt(v.size, v.size + (!v.available ? ' · ' + T('unavailable', 'Temporarily unavailable') : isBO(v.id) ? ' · ' + (BO.badge || 'Preorder') : ''), !v.available)); });
    var hit = rows.filter(function (v) { return v.size === want.size && v.available; })[0] || rows.filter(function (v) { return v.available; })[0];
    if (hit) sZ.value = hit.size;
    card._pair2 = { data: data, variant: function () { var c = sC.value, z = sZ.value; return prod.variants.filter(function (v) { return v.color === c && v.size === z; })[0]; } };
    var add = $('[data-coops-pair2-add]', card); if (add) add.disabled = !hit;
  }
  on(document, 'click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-coops-pair2-open]');
    if (openBtn) {
      var card = openBtn.closest('[data-coops-pair2]'), pick = $('[data-coops-pair2-pick]', card);
      var open = pick.hidden;
      if (open && !card._pair2) pair2Paint(card, false);
      pick.hidden = !open; openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = $('select', pick); if (first) first.focus(); }
      return;
    }
    /* One tap (owner, 2026-10-22): the same style, colour, size and chart as the pair in the bag. If that exact pair
       cannot be added, the picker opens instead. */
    var quick = e.target.closest && e.target.closest('[data-coops-pair2-quick]');
    var addBtn = quick || (e.target.closest && e.target.closest('[data-coops-pair2-add]'));
    if (!addBtn) return;
    var card2 = addBtn.closest('[data-coops-pair2]');
    if (quick && card2 && !card2._pair2) pair2Paint(card2, false);
    var st = card2 && card2._pair2;
    var v = st && st.variant(), msg = $('[data-coops-pair2-msg]', card2);
    if (quick && !(v && v.available && st.data.start && v.size === st.data.start.size && v.color === st.data.start.color)) {
      var ob = $('[data-coops-pair2-open]', card2); if (ob && ob.getAttribute('aria-expanded') !== 'true') ob.click();
      return;
    }
    if (!v || !v.available || addBtn.disabled) return;
    var scale = st.data.start && st.data.start.scale === "Women's" ? 'Women’s' : (st.data.start && st.data.start.scale === "Men's" ? 'Men’s' : (savedScale() || 'Men’s'));
    var was = addBtn.textContent;
    addBtn.disabled = true; addBtn.textContent = T('adding', 'Adding…');
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: poItems(scaleItems([{ id: v.id, quantity: 1 }], scale)) })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || T('add_error', 'Could not add to bag.'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (card2.closest('[data-coops-drawer]')) return refreshDrawer(true);
        location.reload();
      })
      .catch(function (err) {
        addBtn.disabled = false; addBtn.textContent = was;
        if (msg) msg.textContent = String(err.message || err);
      });
  });
  on(document, 'change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-pair2-style], [data-pair2-color], [data-pair2-size]');
    if (sel) pair2Paint(sel.closest('[data-coops-pair2]'), true);
  });

  /* Review strip under the product title (sections/coops-product, Matt's brief Add 1, 2026-10-16): one short quote
     at a time, a new one every 6 s while the strip is on screen; reduced motion keeps the first. */
  (function () {
    var strip = $('[data-coops-revstrip]'); if (!strip) return;
    var line = $('[data-coops-revquote]', strip), list;
    try { list = JSON.parse(($('[data-coops-revstrip-data]', strip) || {}).textContent || '[]'); } catch (e) { list = []; }
    if (!line || !list.length) { strip.hidden = true; return; }
    var i = 0, seen = true;
    function show(k) {
      var r = list[k]; line.textContent = '“' + r.q + '” ';
      var c = document.createElement('cite'); c.textContent = '— ' + r.n; line.appendChild(c);
    }
    show(0);
    if (list.length < 2 || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(strip);
    setInterval(function () {
      if (!seen || document.hidden) return;
      line.classList.add('is-out');
      setTimeout(function () { i = (i + 1) % list.length; show(i); line.classList.remove('is-out'); }, 350);
    }, 6000);
  })();

  function openDrawer() {
    var dlg = $('[data-coops-drawer]');
    if (!dlg || dlg.open) return;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('coops-lock');
    var focusable = $('[data-coops-drawer-close]', dlg);
    if (focusable) focusable.focus();
  }

  function closeDrawer() {
    var dlg = $('[data-coops-drawer]');
    if (!dlg) return;
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    document.documentElement.classList.remove('coops-lock');
  }

  function setLineBusy(line, busy) {
    if (!line) return;
    line.classList.toggle('is-busy', !!busy);
    $$('button', line).forEach(function (b) { b.disabled = !!busy; });
  }

  function changeLine(key, quantity, line) {
    setLineBusy(line, true);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || T('update_error', 'Could not update your bag.')); });
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        setLineBusy(line, false);
        var box = $('[data-coops-cart-error]');
        if (!box) {
          box = document.createElement('p');
          box.className = 'coops-cart__error';
          box.setAttribute('role', 'alert');
          box.setAttribute('data-coops-cart-error', '');
          (line && line.parentNode ? line.parentNode : document.body).insertBefore(box, line || null);
        }
        box.textContent = err.message;
      });
  }

  /* Quantity and remove buttons are real submit buttons (updates[key]=n);
     intercept them so the change happens in place. */
  function initDrawerPanel(root) {
    $$('[data-coops-line]', root).forEach(function (line) {
      var key = line.getAttribute('data-coops-key');
      var q = parseInt(($('.coops-cart__qty-n', line) || {}).textContent, 10) || 1;
      on($('[data-coops-qty-dec]', line), 'click', function (e) { e.preventDefault(); changeLine(key, Math.max(0, q - 1), line); });
      on($('[data-coops-qty-inc]', line), 'click', function (e) { e.preventDefault(); changeLine(key, q + 1, line); });
      on($('[data-coops-remove]', line), 'click', function (e) { e.preventDefault(); changeLine(key, 0, line); });
    });
    $$('[data-coops-drawer-close]', root).forEach(function (b) { on(b, 'click', closeDrawer); });
    revalidateStaleLines(root);
    showStaleNotice(root);
  }

  /* Lines whose preorder properties no longer match the current terms (the
     preorder ended, or Matt changed the promised date) are marked by Liquid
     (data-coops-stale-preorder). They are removed and re-added with the
     current terms — same variant, same quantity — so an old bag cannot
     check out under the expired campaign. A pair that is no longer available
     cannot be re-added; the customer is told. The checkout and wallet
     buttons are held by Liquid until the refreshed render has no stale line. */
  var revalidating = null;
  function revalidateStaleLines(root) {
    var marked = $$('[data-coops-stale-preorder]', root);
    if (!marked.length || revalidating) return revalidating || Promise.resolve(false);
    var r = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    /* Only lines that are in the bag RIGHT NOW (customers, 2026-10-01). A page the browser restores with Back is an old
       copy: its lines may have been removed since, and re-adding them would put a removed pair back in the bag. So read
       the live bag first and act only on marked lines it still holds, at the quantity it holds now. */
    revalidating = fetch(r + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var live = {};
        (cart.items || []).forEach(function (it) { live[it.key] = it.quantity; });
        var stale = marked.filter(function (el) { return live[el.getAttribute('data-key')] > 0; });
        if (!stale.length) {
          revalidating = null;
          /* The page was out of date: bring the counts in line with the real bag, change nothing in it. */
          refreshBagCount();
          return false;
        }
        return runRevalidation(stale, live);
      })
      .catch(function () { revalidating = null; return false; });
    return revalidating;
  }
  function runRevalidation(stale, live) {
    var r = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var removed = [];
    var chain = Promise.resolve();
    stale.forEach(function (el) {
      var key = el.getAttribute('data-key');
      var variant = Number(el.getAttribute('data-variant'));
      var qty = live[key] || Number(el.getAttribute('data-quantity')) || 1;
      var title = el.getAttribute('data-title') || 'An item';
      var props = {};
      try { props = JSON.parse(el.getAttribute('data-props') || '{}'); } catch (e) { props = {}; }
      var purchasable = el.getAttribute('data-purchasable') !== 'no';
      chain = chain
        .then(function () { return fetch(r + 'cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: key, quantity: 0 }) }); })
        .then(function () {
          /* Stock not yet marked received: the pair is temporarily unavailable — it is not re-added as a regular line. */
          if (!purchasable) { removed.push(title + ' (' + T('temp_unavailable', 'temporarily unavailable') + ')'); return { ok: true }; }
          return fetch(r + 'cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: variant, quantity: qty, properties: props }] }) });
        })
        .then(function (res) { if (!res.ok) removed.push(title); })
        .catch(function () { removed.push(title); });
    });
    return chain.then(function () {
      revalidating = null;
      /* Stale lines are refreshed both when preorders end and when the promised terms change while they are still on; say which. */
      var msg = PO.on ? T('po_updated', 'Your bag was updated to the current preorder terms.') : T('po_closed', 'Preorders have closed. Your bag now uses regular ordering.');
      if (removed.length) msg += ' ' + (removed.length > 1 ? T('removed_n', '{items} were removed from your bag.', { items: removed.join(', ') }) : T('removed_one', '{items} was removed from your bag.', { items: removed[0] }));
      try { window.sessionStorage.setItem('coops_stale_notice', msg); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return true;
    });
  }
  function showStaleNotice(root) {
    var msg = '';
    try { msg = window.sessionStorage.getItem('coops_stale_notice') || ''; } catch (e) {}
    if (!msg || $$('[data-coops-stale-preorder]', root).length) return;
    var host = $('[data-coops-drawer-items], [data-coops-cart-items]', root);
    if (!host) return;
    try { window.sessionStorage.removeItem('coops_stale_notice'); } catch (e) {}
    var box = document.createElement('p');
    box.className = 'coops-cart__notice';
    box.setAttribute('role', 'status');
    box.textContent = msg;
    host.insertBefore(box, host.firstChild);
  }

  function initDrawer(root) {
    var dlg = $('[data-coops-drawer]', root);
    if (dlg && !dlg.hasAttribute('data-coops-bound')) {
      dlg.setAttribute('data-coops-bound', '');
      /* Escape on a modal <dialog> fires `cancel` (and, in Chromium, `close`);
         WebKit was observed leaving the scroll lock behind, so clear it on
         both events and on the Escape key itself. */
      on(dlg, 'close', function () { document.documentElement.classList.remove('coops-lock'); });
      on(dlg, 'cancel', function () { document.documentElement.classList.remove('coops-lock'); });
      on(dlg, 'keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); } });
      on(dlg, 'click', function (e) { if (e.target === dlg) closeDrawer(); });
      initDrawerPanel(dlg);
    }
    /* Header bag link opens the drawer instead of leaving the page. */
    $$('[data-coops-bag]', root).forEach(function (a) {
      if (a.hasAttribute('data-coops-bound')) return;
      a.setAttribute('data-coops-bound', '');
      on(a, 'click', function (e) {
        if (!$('[data-coops-drawer]')) return;
        e.preventDefault();
        refreshDrawer(true);
      });
    });
    /* The cart page uses the same line controls; re-render its own blocks. */
    var cartPage = $('[data-coops-cartpage]', root);
    if (cartPage && !cartPage.hasAttribute('data-coops-bound')) {
      cartPage.setAttribute('data-coops-bound', '');
      initDrawerPanel(cartPage);
    }
  }

  /* Bag count (owner, 2026-10-22: "i emptied my cart but it still shows that i have items"): a page can arrive with an
     old count (a saved copy, another tab, a country switch). Shortly after every page load, and whenever the tab comes
     back into view, read the real bag and correct the number if it differs. */
  (function () {
    if (!window.fetch) return;
    var check = function () {
      var shown = $('[data-coops-bag-count]');
      var before = shown ? String(shown.textContent).trim() : '';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (String(cart.item_count) !== before) refreshBagCount(); })
        .catch(function () {});
    };
    var later = function () { if ('requestIdleCallback' in window) requestIdleCallback(check, { timeout: 2500 }); else setTimeout(check, 1200); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
  })();

  /* Back / Forward (customers, 2026-10-01: "removed the items, went back to the home page, the bag still shows one"):
     browsers restore a page from memory exactly as it was, with the bag count it had then. Whenever a page is shown
     again that way, read the real bag: correct the count, and reload the bag page itself if its lines are out of date.
     The slide-out bag already reloads its contents every time it opens. */
  on(window, 'pageshow', function (e) {
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!e.persisted && !(nav && nav.type === 'back_forward')) return;
    if (!window.fetch) return;
    var shown = $('[data-coops-bag-count]');
    var before = shown ? String(shown.textContent).trim() : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (String(cart.item_count) === before) return;
        if ($('[data-coops-cartpage]')) { window.location.reload(); return; }
        refreshBagCount();
      })
      .catch(function () { /* keep what is shown */ });
  });

  on(document, 'cart:refresh', function () {
    var onCartPage = !!$('[data-coops-cartpage]');
    if (onCartPage) { window.location.reload(); return; }
    refreshDrawer(true);
  });

  /* ------------------------------------------------------------ Sticky bar */
  /* Shows once the buy block leaves the viewport. Re-adds the last size that
     was tapped in the picker; before any tap it scrolls back to the sizes. */
  function initSticky(root) {
    var bar = $('[data-coops-sticky]', root);
    if (!bar || bar.hasAttribute('data-coops-bound')) return;
    bar.setAttribute('data-coops-bound', '');
    /* At the footer the bar slides away (owner, 2026-10-22: iPhone Safari stretched the white bar into a band of white
       below the black footer). */
    (function () {
      var foot = document.querySelector('.coops-footer, footer');
      if (!foot || !window.IntersectionObserver) return;
      new IntersectionObserver(function (es) { bar.classList.toggle('coops-sticky--away', es[0].isIntersecting); }, { rootMargin: '0px 0px -40px 0px' }).observe(foot);
    })();
    var picker = $('[data-coops-picker], [data-coops-pdp-form]');
    if (!picker) return;
    var title = $('[data-coops-sticky-title]', bar);
    var meta = $('[data-coops-sticky-meta]', bar);
    var cta = $('[data-coops-sticky-cta]', bar);
    var err = $('[data-coops-sticky-error]', bar);
    var price = cta.getAttribute('data-price') || '';
    /* The page's own price (market currency) rather than the USD fallback setting. */
    function livePrice() {
      var el = $('[data-coops-pdp-price]') || $('.coops-card:not([hidden]) .coops-card__price');
      if (!el) return price;
      /* During a sale the card prints the crossed-out price inside the same element: leave it out of the label. */
      var c = el.cloneNode(true);
      $$('s, del, .coops-visually-hidden', c).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      var t = c.textContent.replace(/\s+/g, ' ').trim();
      return t || price;
    }
    var last = null; /* { id, label, style, colour } */
    var busy = false; /* the bar's own add is in flight: paint() must not overwrite "Adding…" */
    /* Product page: the form is the one source of truth. The bar mirrors the size the form holds and its
       button submits that form, so the bar can never add something the page does not show as chosen.
       On phones the bar shows as soon as a size is chosen (owner, 2026-09-27: the add button sits below
       the fold once a size is tapped), and still gives way to the page's own button when that is on screen. */
    var pdpForm = picker.matches && picker.matches('[data-coops-pdp-form]') ? picker : null;
    var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    /* Only a size the shopper tapped arms the bar (owner, 2026-09-29). A size that arrives in the address — the
       ?variant= of an Instagram, Facebook or Shop link, or the size finder's ?size= — is shown as chosen, but
       the bar waits for a tap. */
    var tappedSize = false;
    function pdpSelection() {
      if (!pdpForm) return null;
      var idEl = $('[data-coops-pdp-id]', pdpForm);
      var pressed = $$('button[data-coops-size][aria-pressed="true"]', pdpForm).filter(function (b) { return !b.hidden; })[0];
      return idEl && idEl.value && pressed ? { id: idEl.value, label: pressed.getAttribute('data-coops-size') } : null;
    }
    /* On the product page the picker IS the form; on activity pages the form sits inside the visible card. */
    function mainForm() {
      if (picker.matches && picker.matches('[data-coops-pdp-form]')) return picker;
      return $('[data-coops-pdp-form], .coops-card:not([hidden]) [data-coops-add-form]', picker);
    }
    function mainButton() {
      return $('[data-coops-pdp-add], .coops-card:not([hidden]) [data-coops-card-cta]', picker.closest('[data-coops-pdp]') || picker);
    }

    function qty() {
      var el = $('[data-coops-pdp-qty], .coops-card:not([hidden]) [data-coops-qty]', picker);
      return el ? (Number(el.value) || 1) : 1;
    }

    function currentStyle() {
      var t = $('[data-coops-style][aria-selected="true"], [data-coops-style].is-on, [data-coops-tab][aria-selected="true"]', picker);
      if (t) return t.textContent.trim();
      /* The product page has one style: name it from the page heading. */
      var h1 = $('h1');
      return h1 ? h1.textContent.trim() : '';
    }
    function currentColour() {
      var c = $('[data-coops-color][aria-pressed="true"], [data-coops-color].is-on, [data-coops-color]:checked', picker);
      return c ? (c.getAttribute('data-coops-color') || c.value || '') : '';
    }
    /* 2+ pairs: the builder rows that still read "pick a size". */
    function pendingPair() {
      return $$('[data-coops-builder] li', picker).filter(function (li) { return li.hasAttribute('data-pair-pending') || /pick a size/i.test(li.textContent); })[0] || null;
    }
    function editRoot() { return picker.closest ? picker.closest('[data-coops-edit]') : null; }
    function paint() {
      if (busy) return;
      var s = currentStyle(), c = currentColour();
      title.textContent = [s, CN(c)].filter(Boolean).join(' · ') || document.title.split('|')[0].trim();
      if (editRoot()) {
        /* Bag edit: the product form owns the selection; the bar mirrors it and its button submits that form. */
        var idEl = $('[data-coops-pdp-id]', editRoot());
        var pressed = $$('button[data-coops-size][aria-pressed="true"]', editRoot()).filter(function (b) { return !b.hidden; })[0];
        var has = !!(idEl && idEl.value);
        meta.textContent = has && pressed ? T('size_n', 'Size {size}', { size: pressed.getAttribute('data-coops-size') }) : T('choose_size', 'Choose a size');
        cta.textContent = has ? T('update_bag', 'Update bag') : T('select_size', 'Select your size');
        if (!PO_OK) { cta.disabled = true; cta.textContent = T('unavailable', 'Temporarily unavailable'); }
        return;
      }
      if (qty() > 1) {
        if (pendingPair()) {
          meta.textContent = T('pairs_choose', '{n} pairs · choose each size', { n: qty() });
          cta.textContent = T('select_each', 'Select each pair’s size');
        } else {
          /* Every pair sized: mirror the main button (same selection state on the sticky control, audit 2026-09-15). */
          /* The label follows the main button through "Adding…" / "Added" and back: the observer below
             repaints on every change of that button, so the bar can no longer be left on a transient
             label (owner, 2026-09-18: stuck on "Adding…"). */
          var mainBtn = mainButton();
          meta.textContent = T('pairs_chosen', '{n} pairs · sizes chosen', { n: qty() });
          cta.textContent = mainBtn && mainBtn.textContent.trim() ? mainBtn.textContent.trim() : poWord(qty());
          cta.disabled = !!(mainBtn && mainBtn.disabled);
        }
        if (!PO_OK) { cta.disabled = true; cta.textContent = T('unavailable', 'Temporarily unavailable'); }
        return;
      }
      if (pdpForm) {
        /* One pair on the product page: the form's own selection and the main button's own label ("Adding…" and "Added" included). */
        var sel = pdpSelection();
        var mbtn = mainButton();
        if (sel) {
          meta.textContent = T('size_n', 'Size {size}', { size: sel.label });
          cta.textContent = mbtn && mbtn.textContent.trim() ? mbtn.textContent.trim() : poWord(1) + (livePrice() ? ' · ' + moneyLabel(livePrice()) : '');
          cta.disabled = !!(mbtn && mbtn.disabled);
        } else {
          meta.textContent = T('choose_size', 'Choose a size');
          cta.textContent = T('select_size', 'Select your size');
          cta.disabled = false;
        }
        if (!PO_OK) { cta.disabled = true; cta.textContent = T('unavailable', 'Temporarily unavailable'); }
        return;
      }
      if (last && last.style === s && last.colour === c) {
        meta.textContent = T('size_n', 'Size {size}', { size: last.label });
        cta.textContent = poWord(qty()) + (qty() > 1 ? '' : (livePrice() ? ' · ' + moneyLabel(livePrice()) : ''));
      } else {
        meta.textContent = T('choose_size', 'Choose a size');
        cta.textContent = T('select_size', 'Select your size');
        if (!PO_OK) { cta.disabled = true; cta.textContent = T('unavailable', 'Temporarily unavailable'); }
      }
    }

    /* Remember the last size tapped: the size buttons submit variant ids. */
    on(picker, 'click', function (e) {
      var tapped = e.target.closest('[data-coops-size], [data-pair-size]');
      if (tapped && !tapped.disabled) tappedSize = true;
      var b = e.target.closest('[data-coops-size]');
      if (!b || b.disabled) return;
      last = { id: b.value, label: b.getAttribute('data-coops-size'), style: currentStyle(), colour: currentColour() };
      setTimeout(paint, 0);
    });
    /* Any tap in the picker can change what is chosen: repaint, and re-decide whether the bar shows (a size chosen on a phone shows it at once). */
    on(picker, 'click', function () { setTimeout(function () { paint(); update(); }, 0); });

    on(cta, 'click', function () {
      err.hidden = true;
      if (editRoot()) {
        var fe = picker.matches && picker.matches('[data-coops-pdp-form]') ? picker : $('[data-coops-pdp-form]', editRoot());
        if (fe) { if (typeof fe.requestSubmit === 'function') fe.requestSubmit(); else fe.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        return;
      }
      /* With 2+ pairs the builder owns the add. A pair without a size: open its editor and bring it into view (owner, live 2026-09-15: the phone button did nothing). */
      if (qty() > 1) {
        var need = pendingPair();
        if (need) {
          var tog = $('[data-pair-toggle]', need);
          if (tog && !/close/i.test(tog.textContent)) tog.click();
          need.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(paint, 0);
          return;
        }
        /* The builder's own form adds the chosen pairs. Never fall through to the single-pair add
           below: that would add qty x the last size tapped, not the pairs the customer built. */
        var f = mainForm();
        if (f) { if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        setTimeout(paint, 0);
        return;
      }
      var goToSizes = function () {
        var sizes = $$('[data-coops-size]:not([disabled])', picker).filter(function (b) { return !b.hidden && b.offsetParent !== null; })[0] || $('.coops-sizes', picker) || picker;
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { sizes.focus && sizes.focus(); }, 400);
      };
      /* Product page: the form adds what it shows as chosen; the bar holds no selection of its own there. */
      if (pdpForm) {
        if (!pdpSelection()) { goToSizes(); return; }
        if (typeof pdpForm.requestSubmit === 'function') pdpForm.requestSubmit(); else pdpForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        setTimeout(paint, 0);
        return;
      }
      if (!last || last.style !== currentStyle() || last.colour !== currentColour()) { goToSizes(); return; }
      var was = cta.textContent;
      busy = true;
      cta.disabled = true;
      cta.textContent = T('adding', 'Adding…');
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: poItems(scaleItems([{ id: last.id, quantity: qty() }], (($('.coops-gender__btn[aria-pressed="true"]', picker) || { getAttribute: function () { return savedScale(); } }).getAttribute('data-coops-gender')))) }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || T('add_error', 'Could not add to bag.')); });
          return r.json();
        })
        .then(function () {
          cta.textContent = T('added', 'Added');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { busy = false; cta.disabled = false; cta.textContent = was; paint(); }, 900);
        })
        .catch(function (e2) {
          busy = false;
          err.textContent = e2.message;
          err.hidden = false;
          cta.disabled = false;
          cta.textContent = was;
        });
    });

    /* Repaint whenever a main add button changes (label or disabled), whoever pressed it. */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { setTimeout(paint, 0); });
      $$('[data-coops-pdp-add], [data-coops-card-cta]', picker.closest('[data-coops-pdp]') || picker).forEach(function (b) {
        mo.observe(b, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      });
    }
    on(document, 'cart:refresh', function () { setTimeout(paint, 1500); });

    /* Visibility follows the buy block: shown only once the size grid has
       scrolled above the viewport. Measured on each scroll frame rather than
       through IntersectionObserver, whose notifications can be skipped
       around a modal open/close and leave the bar stuck hidden. */
    var target = $('[data-coops-sizes], .coops-sizes, .coops-pick', picker) || picker;
    var ticking = false;
    function update() {
      ticking = false;
      var r = target.getBoundingClientRect();
      var onScreen = r.bottom > 0 && r.top < window.innerHeight;
      var below = r.top >= window.innerHeight;
      /* Owner, 2026-09-18: the bar must not show while the page's own add button is on screen. */
      var mb = mainButton(), mainVisible = false;
      if (mb) { var br = mb.getBoundingClientRect(); mainVisible = br.width > 0 && br.bottom > 0 && br.top < window.innerHeight; }
      /* Phones, product page (owner, 2026-09-27): once a size is chosen — every pair's, with 2+ pairs — the bar shows
         wherever the page is scrolled, so the add button is always within reach. Elsewhere it waits for the size grid to leave the top. */
      var armed = !!(pdpForm && tappedSize && phoneMq && phoneMq.matches && (qty() > 1 ? !pendingPair() : pdpSelection()));
      var wasHidden = bar.hidden;
      /* Phones, product page, before a size is tapped (2026-10-13, replaces the 2026-09-29 rule of no bar at all):
         "Select your size" is pinned from the first screen whenever the size grid and the add button are both off
         screen, above or below, so a visitor from an ad reaches the sizes in one tap. */
      var phonePdp = !!(pdpForm && phoneMq && phoneMq.matches);
      /* ...but never over the title, price, stars and bundle line: those belong on the first screen. */
      var head = phonePdp ? $('.coops-pdp__titlerow') : null, headVisible = false;
      if (head) { var hr = head.getBoundingClientRect(); var hb = $('[data-coops-bundle-line]'); var hbr = hb && !hb.hidden ? hb.getBoundingClientRect() : hr; headVisible = Math.max(hr.bottom, hbr.bottom) > 0 && hr.top < window.innerHeight; }
      if (phonePdp && !armed) bar.hidden = mainVisible || onScreen || headVisible;
      else bar.hidden = mainVisible || (!armed && (onScreen || below));
      if (wasHidden && !bar.hidden) paint();
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });
    /* Belt and braces: if any layout makes .page-wrapper the scroller again, follow it too. */
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) on(wrapper, 'scroll', onScroll, { passive: true });
    update();
    paint();
  }

  /* ---------------------------------------------------------------- Footer */
  /* The footer columns render open (desktop design). On phones they become
     accordions: closed by default, remembering what the visitor opened, and
     re-opened when the viewport grows to the desktop layout. */
  function initFooter(root) {
    var cols = $$('[data-coops-footer-col]', root);
    if (!cols.length) return;
    var mq = window.matchMedia('(min-width: 900px)');
    function sync() {
      cols.forEach(function (d) {
        if (mq.matches) d.open = true;
        else d.open = d.getAttribute('data-user-open') === 'true';
      });
    }
    cols.forEach(function (d) {
      on(d, 'toggle', function () { if (!mq.matches) d.setAttribute('data-user-open', d.open ? 'true' : 'false'); });
    });
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  }

  /* ------------------------------------------------------------------ FAQ */
  /* Category chips filter the <details>; one control expands or collapses
     every visible answer. On desktop the approved page opens all answers. */
  function initFaq(root) {
    $$('[data-coops-faq]', root).forEach(function (sec) {
      if (sec.hasAttribute('data-coops-bound')) return;
      sec.setAttribute('data-coops-bound', '');
      var tools = $('[data-coops-faq-tools]', sec);
      var items = $$('.coops-faq__item', sec);
      var toggle = $('[data-coops-faq-toggle]', sec);
      var chips = $$('[data-coops-faq-cat]', tools || sec).filter(function (b) { return b.tagName === 'BUTTON'; });
      function visible() { return items.filter(function (d) { return !d.hidden; }); }
      function paintToggle() {
        if (!toggle) return;
        var vis = visible();
        var allOpen = vis.length > 0 && vis.every(function (d) { return d.open; });
        toggle.textContent = allOpen ? T('collapse_all', 'Collapse all') : T('expand_all', 'Expand all');
        toggle.setAttribute('aria-pressed', allOpen ? 'true' : 'false');
      }
      if (tools) tools.hidden = false;
      chips.forEach(function (chip) {
        on(chip, 'click', function () {
          var cat = chip.getAttribute('data-coops-faq-cat') || '';
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          items.forEach(function (d) { d.hidden = !!cat && d.getAttribute('data-coops-faq-cat') !== cat; });
          paintToggle();
        });
      });
      if (toggle) {
        on(toggle, 'click', function () {
          var open = toggle.getAttribute('aria-pressed') !== 'true';
          visible().forEach(function (d) { d.open = open; });
          paintToggle();
        });
      }
      items.forEach(function (d) { on(d, 'toggle', paintToggle); });
      if (sec.hasAttribute('data-open-default') && window.matchMedia('(min-width: 900px)').matches) {
        items.forEach(function (d) { d.open = true; });
      }
      paintToggle();
    });
  }

  /* ------------------------------------------------------------ Size finder */
  /* Size guide page on phones: Women's / Men's tiles show the letter for a US
     size, the chart row lights up and "Shop this size" carries the pick to the
     product page (?gender=womens&size=S). */
  $$('[data-coops-sizefinder]').forEach(function (root) {
    var genderBtns = $$('[data-coops-finder-gender]', root);
    var groups = $$('[data-coops-finder-tiles]', root);
    var label = $('[data-coops-finder-label]', root);
    var letter = $('[data-coops-finder-letter]', root);
    var shop = $('[data-coops-finder-shop]', root);
    var wide = $('[data-coops-finder-wide]', root);
    /* Every COOPS letter in chart order (the table rows), for "one letter larger". */
    var letters = $$('[data-coops-finder-row]').map(function (r) { return r.getAttribute('data-coops-finder-row'); });
    var base = root.getAttribute('data-shop-url') || '/products/coops-low-top';
    var names = { womens: T('womens', 'Women’s'), mens: T('mens', 'Men’s') };
    var picked = { womens: root.getAttribute('data-default-womens') || 'S', mens: root.getAttribute('data-default-mens') || 'M' };
    var gender = savedScale() === 'Women’s' ? 'womens' : 'mens';
    function render() {
      var us = '';
      genderBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-coops-finder-gender') === gender ? 'true' : 'false'); });
      groups.forEach(function (g) {
        var on = g.getAttribute('data-coops-finder-tiles') === gender;
        g.hidden = !on;
        $$('[data-coops-finder-size]', g).forEach(function (t) {
          var hit = t.getAttribute('data-coops-finder-size') === picked[gender];
          t.setAttribute('aria-pressed', hit ? 'true' : 'false');
          if (on && hit) us = t.getAttribute('data-us') || '';
        });
      });
      if (label) label.textContent = T('finder_is', '{gender} US {us} is a', { gender: names[gender], us: us });
      if (letter) letter.textContent = picked[gender];
      if (wide) {
        var idx = letters.indexOf(picked[gender]);
        var next = idx > -1 && idx < letters.length - 1 ? letters[idx + 1] : '';
        if (!next) wide.textContent = T('wide_max', 'Wide feet? {size} is the largest COOPS letter we make; there is no wider option.', { size: picked[gender] });
        else {
          var inChart = groups.some(function (g) { return g.getAttribute('data-coops-finder-tiles') === gender && !!$('[data-coops-finder-size="' + next + '"]', g); });
          wide.textContent = T('wide_next', 'Wide feet? Choose one letter larger: {size}', { size: next }) + (inChart ? '.' : ' (' + T('wide_other', 'listed on the {gender} chart', { gender: gender === 'womens' ? names.mens : names.womens }) + ').');
        }
      }
      if (shop) shop.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'gender=' + gender + '&size=' + encodeURIComponent(picked[gender]));
      $$('[data-coops-finder-row]').forEach(function (r) { r.classList.toggle('is-picked', r.getAttribute('data-coops-finder-row') === picked[gender]); });
    }
    genderBtns.forEach(function (b) { on(b, 'click', function () { gender = b.getAttribute('data-coops-finder-gender'); saveScale(gender === 'womens' ? 'Women’s' : 'Men’s'); render(); }); });
    groups.forEach(function (g) {
      $$('[data-coops-finder-size]', g).forEach(function (t) {
        on(t, 'click', function () { picked[g.getAttribute('data-coops-finder-tiles')] = t.getAttribute('data-coops-finder-size'); render(); });
      });
    });
    render();
  });

  /* ------------------------------------------------- Country / currency */
  /* The native localization form: a change submits it (market + currency switch, bag kept); the Update button stays for no-JS. */
  function initCountry(root) {
    /* the flag toggle next to the bag: remember the language the visitor picked */
    $$('form[data-coops-flag]', root).forEach(function (f) {
      if (f.hasAttribute('data-coops-bound')) return;
      f.setAttribute('data-coops-bound', '');
      on(f, 'submit', function (e) {
        var v = (e && e.submitter && e.submitter.value) || f.getAttribute('data-coops-flag');
        try { document.cookie = 'coops_lang=' + encodeURIComponent(v) + '; path=/; max-age=31536000; samesite=lax'; } catch (err) {}
      });
      /* the flag menu closes on a tap outside it or on Escape */
      var menu = f.closest('details');
      if (menu) {
        on(document, 'click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
        on(document, 'keydown', function (e) { if (e.key === 'Escape' && menu.open) { menu.open = false; var s = menu.querySelector('summary'); if (s) s.focus(); } });
      }
    });
    $$('.coops-country', root).forEach(function (f) {
      if (f.hasAttribute('data-coops-bound')) return;
      f.setAttribute('data-coops-bound', '');
      f.classList.add('is-js');
      /* country and (where the market has two) language: either select submits the form */
      $$('select[name="country_code"], select[name="locale_code"]', f).forEach(function (sel) {
        on(sel, 'change', function () {
          /* a language picked here is the visitor's choice: coops-lang-route stops sending them to their country's language */
          if (sel.name === 'country_code') {
            /* a country picked here wins over the location check (coops-lang-route) for the rest of this visit only: the next
               visit checks the location again (owner, 2026-10-22). Session cookie, no expiry. */
            try { document.cookie = 'coops_country_s=' + encodeURIComponent(sel.value) + '; path=/; samesite=lax'; } catch (e) {}
          }
          if (sel.name === 'locale_code') {
            try { document.cookie = 'coops_lang=' + encodeURIComponent(sel.value) + '; path=/; max-age=31536000; samesite=lax'; } catch (e) {}
          }
          if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit();
        });
      });
    });
  }

  /* ---------------------------------------------------------------- Account */
  function initAccount(root) {
    $$('[data-coops-account]', root).forEach(function (acc) {
      var tabs = $$('[data-acc-tab]', acc);
      var panels = $$('[data-acc-panel]', acc);
      function show(name) {
        acc.setAttribute('data-tab', name);
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-acc-tab') === name ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-acc-panel') !== name; });
        try { history.replaceState(null, '', '#' + name); } catch (e) {}
      }
      tabs.forEach(function (t) { on(t, 'click', function () { show(t.getAttribute('data-acc-tab')); }); });
      var wanted = (location.hash || '').replace('#', '');
      if (wanted && tabs.some(function (t) { return t.getAttribute('data-acc-tab') === wanted; })) show(wanted);
      /* Reorder: the order's lines back into the bag, then the drawer. */
      $$('[data-acc-reorder]', acc).forEach(function (btn) {
        on(btn, 'click', function () {
          var items;
          try { items = JSON.parse(btn.getAttribute('data-acc-reorder')); } catch (e) { return; }
          if (!items || !items.length || btn.disabled) return;
          btn.disabled = true;
          var label = btn.textContent;
          btn.textContent = T('adding', 'Adding…');
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: poItems(items) })
          }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); return refreshDrawer(true); })
            .catch(function () { btn.textContent = T('try_again', 'Try again'); })
            .then(function () { btn.disabled = false; if (btn.textContent === T('adding', 'Adding…')) btn.textContent = label; });
        });
      });
    });
  }

  /* ----------------------------------------------------------------- Boot */
  // Horizontal rails that actually overflow (phones) need keyboard access:
  // give them a tab stop and a name from the section heading so a keyboard
  // user can scroll them (WCAG 2.1.1; axe scrollable-region-focusable).
  function initRails(root) {
    var rails = $$('.coops-rail, .coops-wear__grid, .coops-lpgal__grid, .coops-sizechart__scroll, .coops-rates__wrap', root);
    function apply() {
      rails.forEach(function (r) {
        var scrolls = r.scrollWidth > r.clientWidth + 2;
        if (scrolls && !r.hasAttribute('tabindex')) {
          r.setAttribute('tabindex', '0');
          if (!r.getAttribute('role')) r.setAttribute('role', 'group');
          if (!r.getAttribute('aria-label')) {
            var sec = r.closest('section, .coops-section, [aria-labelledby]');
            var id = sec && sec.getAttribute('aria-labelledby');
            var h = (id && document.getElementById(id)) || (sec && sec.querySelector('h1, h2, h3'));
            r.setAttribute('aria-label', (h ? h.textContent.trim().replace(/\s+/g, ' ') + ' ' : '') + 'scrollable list');
          }
        } else if (!scrolls && r.getAttribute('data-coops-rail-tab') === '1') {
          r.removeAttribute('tabindex');
        }
        if (scrolls) r.setAttribute('data-coops-rail-tab', '1');
      });
    }
    apply();
    var t; on(window, 'resize', function () { clearTimeout(t); t = setTimeout(apply, 150); });
    // tab panels (ways to wear) become scrollable only once shown
    on(document, 'click', function (e) { if (e.target && e.target.closest && e.target.closest('[role="tab"], [data-coops-tab]')) setTimeout(apply, 60); });
  }

  /* Reviews page list: fetches assets/coops-reviews.json, filters by style or
     colour (chips), shows nine at a time ("Load 9 more"), collapses back. */
  function initReviewsList(root) {
    var box = $('[data-coops-reviews]', root);
    if (!box) return;
    var grid = $('[data-coops-rgrid]', box), count = $('[data-coops-rcount]', box), more = $('[data-coops-rmore]', box), less = $('[data-coops-rless]', box);
    var chips = $$('[data-coops-rfilter]', box);
    var page = Number(box.getAttribute('data-page')) || 9, moreLabel = more ? more.textContent : 'Load [[n]] more';
    var all = [], filter = '', shown = page;
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function stars(n) { var out = ''; for (var i = 1; i <= 5; i++) out += i <= n ? '★' : '☆'; return out; }
    function list() { return all.filter(function (r) { return !filter || r.style === filter || r.color === filter; }); }
    function render() {
      var l = list(), cards = l.slice(0, shown), html = '';
      cards.forEach(function (r) {
        var meta = [r.style, r.color, r.size ? 'Size ' + r.size : ''].filter(Boolean).join(' • ');
        html += '<article class="coops-rcard"><div class="coops-rcard__top"><span class="coops-rcard__stars" aria-label="' + (r.rating || 5) + ' out of 5 stars">' + stars(r.rating || 5) + '</span><span class="coops-rcard__verified">Verified</span></div>' + (r.title ? '<h2 class="coops-rcard__title">' + esc(r.title) + '</h2>' : '') + '<p class="coops-rcard__quote">' + esc(r.quote) + '</p><div class="coops-rcard__foot"><span class="coops-rcard__name">' + esc(r.name) + '</span><span class="coops-rcard__meta">' + esc(meta) + '</span></div></article>';
      });
      grid.innerHTML = html || '<p class="coops-rlist__empty">No reviews match that filter yet.</p>';
      if (count) count.textContent = 'Showing ' + cards.length + ' of ' + l.length + ' reviews';
      var left = l.length - cards.length;
      if (more) { more.hidden = left <= 0; more.textContent = moreLabel.replace('[[n]]', String(Math.min(page, Math.max(left, 0)))); }
      if (less) less.hidden = shown <= page;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', (c.getAttribute('data-coops-rfilter') || '') === filter ? 'true' : 'false'); });
    }
    chips.forEach(function (c) { on(c, 'click', function () { filter = c.getAttribute('data-coops-rfilter') || ''; shown = page; render(); }); });
    on(more, 'click', function () { shown += page; render(); });
    on(less, 'click', function () { shown = page; render(); grid.scrollIntoView({ block: 'start', behavior: 'smooth' }); });
    fetch(box.getAttribute('data-src'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) { all = Array.isArray(data) ? data : []; render(); }).catch(function () { grid.innerHTML = '<p class="coops-rlist__empty">Reviews could not be loaded.</p>'; });
  }

  /* Sticky header offset: the announcement bar's height, so #header-group
     sticks with the bar scrolled away and the navigation flush at the top. */

  /* Phone/tablet product page: the style switch is sticky under the header until the title row reaches it. */
  function initStickySwitch() {
    var sw = $('.coops-pdp__styles-top'); var title = $('.coops-pdp__titlerow');
    if (!sw || !title || sw.hasAttribute('data-coops-bound')) return;
    sw.setAttribute('data-coops-bound', '');
    function tick() {
      var top = parseFloat(getComputedStyle(sw).top) || 0;
      var r = title.getBoundingClientRect();
      sw.classList.toggle('is-released', r.top <= top + sw.offsetHeight + 8);
    }
    on(window, 'scroll', tick, { passive: true }); on(window, 'resize', tick); tick();
  }

  function initStickyHeader() {
    var ann = $('.coops-announcement');
    var group = $('#header-group');
    function set() { document.documentElement.style.setProperty('--coops-ann-h', (ann && ann.offsetParent !== null ? ann.offsetHeight : 0) + 'px'); if (group) document.documentElement.style.setProperty('--coops-header-group-h', group.offsetHeight + 'px'); }
    set();
    var t; on(window, 'resize', function () { clearTimeout(t); t = setTimeout(set, 120); });
  }

  /* Header wordmark (owner, 2026-09-16: "the COOPS logo button at the top of mobile
     should lead customers back to the top of the home page"). A tap on a link to the
     page already open is treated as a reload by Chrome and Safari, which then restore
     the old scroll position, so the customer stays where they were. On the home page
     the tap now scrolls to the top (and closes the menu if it is open); from any
     other page the link navigates to the home page as before. */
  function initLogoTop(root) {
    $$('.coops-header__logo', root).forEach(function (a) {
      on(a, 'click', function (e) {
        var here = location.pathname.replace(/\/+$/, '');
        var there = (a.pathname || '/').replace(/\/+$/, '');
        if (here !== there) return;
        e.preventDefault();
        var menu = $('[data-coops-menu]', root);
        if (menu && menu.getAttribute('open-state') === 'true') {
          var close = $('[data-coops-menu-close]', menu);
          if (close) close.click();
        }
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function boot(root) {
    initLogoTop(root);
    initAccount(root);
    initStickyHeader();
    initStickySwitch();
    initReviewsList(root);
    initRails(root);
    initFaq(root);
    initHeader(root);
    initHero(root);
    initPicker(root);
    initPdp(root);
    initDialogs(root);
    initTabs(root);
    initDrawer(root);
    initSticky(root);
    initCountry(root);
    initFooter(root);
  }

  if (document.readyState === 'loading') {
    on(document, 'DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* High Top / Low Top switch on the product page (owner, 2026-10-23: "the page jumps and seems to reload"): the two
     styles are separate products, so the switch was a full page load. Now the product section of the other page is
     fetched (started early, on hover or touch) and swapped in place: the scroll position stays, the colour, size chart,
     size and number of pairs carry over, and the address bar and title follow. Back / Forward swap again. Any failure
     falls back to the normal page load. Activity pages keep their links. */
  (function () {
    if (!window.fetch || !window.DOMParser || !window.history || !history.pushState) return;
    if (!document.body || !/\btemplate-product\b/.test(document.body.className)) return;
    var cache = {};
    function sectionOf(pdp) { return pdp && pdp.closest('.shopify-section'); }
    function load(url) {
      var key = url.split('?')[0];
      if (!cache[key]) cache[key] = fetch(key, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .catch(function (e) { delete cache[key]; throw e; });
      return cache[key];
    }
    function pick(pdp) {
      var q = function (s) { return pdp.querySelector(s); };
      var col = q('[data-coops-color][aria-pressed="true"]'), gen = q('.coops-gender__btn[data-coops-gender][aria-pressed="true"]');
      var size = pdp.querySelector('button[data-coops-size][aria-pressed="true"]:not([data-pair-size]):not([hidden])');
      var tier = q('[data-coops-tier][aria-pressed="true"]');
      return { color: col && col.getAttribute('data-coops-color'), gender: gen && gen.getAttribute('data-coops-gender'), size: size && size.getAttribute('data-coops-size'), qty: tier ? Number(tier.getAttribute('data-coops-tier')) : 1 };
    }
    var busy = false;
    function swap(url, push) {
      var pdp = document.querySelector('[data-coops-pdp]'), sec = sectionOf(pdp);
      if (!pdp || !sec || busy || pdp.hasAttribute('data-coops-edit')) { location.href = url; return; }
      busy = true;
      var keep = pick(pdp);
      pdp.classList.add('is-swapping');
      load(url).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sec.id) || (doc.querySelector('[data-coops-pdp]') || {}).closest && doc.querySelector('[data-coops-pdp]').closest('.shopify-section');
        if (!fresh || !fresh.querySelector('[data-coops-pdp]')) throw new Error('no section');
        /* the page reads ?gender, ?size and ?pairs on start: hand the current choice over that way */
        var path = url.split('?')[0], qs = [];
        if (keep.gender) qs.push('gender=' + (keep.gender === 'Women’s' ? 'womens' : 'mens'));
        if (keep.size) qs.push('size=' + encodeURIComponent(keep.size));
        if (keep.qty > 1) qs.push('pairs=' + keep.qty);
        if (push) history.pushState({ coopsStyle: path }, '', path); else history.replaceState({ coopsStyle: path }, '', path);
        var tmp = path + (qs.length ? '?' + qs.join('&') : '');
        history.replaceState(history.state, '', tmp);
        var y = window.scrollY;
        sec.innerHTML = fresh.innerHTML;
        boot(sec);
        history.replaceState(history.state, '', path);
        var np = sec.querySelector('[data-coops-pdp]');
        if (np) np.classList.add('is-swapped');
        if (np && keep.color) { var sw = np.querySelector('[data-coops-color="' + keep.color.replace(/"/g, '') + '"]'); if (sw && sw.getAttribute('aria-pressed') !== 'true') sw.click(); }
        if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
        if (doc.title) document.title = doc.title;
        var c1 = document.querySelector('link[rel=canonical]'), c2 = doc.querySelector('link[rel=canonical]'); if (c1 && c2) c1.href = c2.href;
        try { if (window.posthog && window.posthog.capture) window.posthog.capture('$pageview'); } catch (e) {}
        busy = false;
      }).catch(function () { busy = false; location.href = url; });
    }
    function styleLink(t) { var a = t && t.closest && t.closest('a.coops-pdp__style'); return a && a.closest('[data-coops-pdp]') && !a.classList.contains('is-current') && a.getAttribute('href') && a.getAttribute('href') !== '#' ? a : null; }
    var warm = function (e) { var a = styleLink(e.target); if (a) load(a.href).catch(function () {}); };
    /* Fetch the other style quietly once the page is idle, so the switch is near-instant (skipped on Save-Data). */
    var idle = function () { if (navigator.connection && navigator.connection.saveData) return; var o = document.querySelector('a.coops-pdp__style:not(.is-current)'); if (o && o.closest('[data-coops-pdp]') && o.getAttribute('href') !== '#') load(o.href).catch(function () {}); };
    var later = function () { setTimeout(function () { if ('requestIdleCallback' in window) requestIdleCallback(idle, { timeout: 4000 }); else idle(); }, 2500); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    on(document, 'pointerover', warm);
    on(document, 'touchstart', warm, { passive: true });
    on(document, 'click', function (e) {
      var a = styleLink(e.target);
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      swap(a.href, true);
    });
    history.replaceState(Object.assign({}, history.state || {}, { coopsStyle: location.pathname }), '');
    on(window, 'popstate', function (e) {
      if (!e.state || !e.state.coopsStyle) return;
      var cur = document.querySelector('a.coops-pdp__style.is-current');
      if (cur && cur.pathname === location.pathname) return;
      swap(location.pathname, false);
    });
  })();

  /* Theme editor re-renders sections in place */
  on(document, 'shopify:section:load', function (e) { boot(e.target); });
  on(document, 'shopify:section:select', function (e) { boot(e.target); });
})();

/* Klaviyo "Added to Cart" (owner, 2026-10-10): the bag adds pairs with fetch('/cart/add.js') and never reloads the
   page, so Klaviyo's own script cannot see it. Every successful add, wherever it starts (product page, quick add,
   bundles, bag edits), is reported once here in Klaviyo's standard Added to Cart shape, so a cart-abandonment flow
   can trigger on it. Klaviyo only records it for visitors it already knows (email click or sign-up) and who allowed
   tracking. Nothing else changes: the original response goes back to the caller untouched. */
(function () {
  if (!window.fetch || window.__coopsKlAtc) return;
  window.__coopsKlAtc = true;
  var nativeFetch = window.fetch;
  var origin = location.origin;
  function track(added) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    nativeFetch.call(window, root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = added.items ? added.items[added.items.length - 1] : added;
      if (!item || !item.product_id) return;
      var img = item.image || (item.featured_image && item.featured_image.url) || '';
      var payload = {
        $value: cart.total_price / 100,
        AddedItemProductName: item.product_title,
        AddedItemProductID: String(item.product_id),
        AddedItemVariantID: String(item.variant_id || item.id),
        AddedItemSKU: item.sku || '',
        AddedItemImageURL: img,
        AddedItemURL: origin + (item.url || ''),
        AddedItemPrice: item.final_price / 100,
        AddedItemQuantity: item.quantity,
        ItemNames: cart.items.map(function (i) { return i.product_title; }),
        CheckoutURL: origin + root + 'checkout',
        Items: cart.items.map(function (i) {
          return { ProductID: String(i.product_id), SKU: i.sku || '', ProductName: i.product_title, VariantName: i.variant_title || '',
            Quantity: i.quantity, ItemPrice: i.final_price / 100, RowTotal: i.final_line_price / 100,
            ProductURL: origin + i.url, ImageURL: i.image || '' };
        })
      };
      var kl = window.klaviyo || (window._learnq = window._learnq || []);
      kl.push(['track', 'Added to Cart', payload]);
    }).catch(function () {});
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (res && res.ok) res.clone().json().then(track).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };
})();
